var kr = (i) => {
  throw TypeError(i);
};
var Ni = (i, e, t) => e.has(i) || kr("Cannot " + t);
var f = (i, e, t) => (Ni(i, e, "read from private field"), t ? t.call(i) : e.get(i)), L = (i, e, t) => e.has(i) ? kr("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t), P = (i, e, t, r) => (Ni(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $ = (i, e, t) => (Ni(i, e, "access private method"), t);
var ni = (i, e, t, r) => ({
  set _(s) {
    P(i, e, s, t);
  },
  get _() {
    return f(i, e, r);
  }
});
import { jsx as b, jsxs as j, Fragment as Ti } from "react/jsx-runtime";
import { Checkbox as ea, ActionMenu as ta, LanguageCodeEnum as Ai, Modal as bi, PrimaryButton as ti, SecondaryButton as Bs, FieldErrorAndDescription as ui, ActionMenuItem as wi, FormInputSearch as ia, FormSelectMultiple as Mr, Loader as ra, toast as be, CheckBoxSwitcher as sa, useWindowSize as na, FormInput as aa, ModalSizeEnum as oa } from "@systemeio/ui";
import * as ce from "react";
import Oe, { createContext as Hs, useContext as la, useState as V, useRef as we, useEffect as Ee, useCallback as ca, Children as ua, memo as ha } from "react";
import { twMerge as ie } from "tailwind-merge";
import { CloseIcon as Tr, InfoIcon as da, BinIcon as fa, PenIcon as pa, DownloadIcon as ma, CloseCircleIcon as Ar, SmallPenIcon as ga, UploadIcon as va } from "@systemeio/ui/icons";
import { getTFuncWithNamespace as ya, getUseLocoTranslation as ba, createHttpClient as wa, getUseBaseFetch as xa, RequestMethodsEnum as gt, BadRequest as Ca } from "@systemeio/util";
import { flushSync as Sa } from "react-dom";
import pr from "axios";
var ze = /* @__PURE__ */ ((i) => (i.Docx = ".docx", i.Doc = ".doc", i.Ttf = ".ttf", i.AD_PRT = ".AD_PRT", i.AD_SMP = ".AD_SMP", i.AD_ASM = ".AD_ASM", i.AD_DRW = ".AD_DRW", i))(ze || {}), G = /* @__PURE__ */ ((i) => (i.Editor = "editor", i.Community = "community", i.BlockPreview = "block_preview", i.Membership = "membership", i.Marketplace = "marketplace", i.Settings = "settings", i.Email = "email", i.Ckeditor = "ckeditor", i.TextEditor = "text_editor", i.BlogPost = "blog_post", i.PageTemplate = "page_template", i.PageTemplatePreview = "page_template_preview", i.BlogTemplatePreview = "blog_template_preview", i.EmailTemplate = "email_template", i.WebsiteTemplate = "website_template", i.Product = "product", i.FunnelTemplatePreview = "funnel_template_preview", i.DigitalStore = "digital_store", i.DigitalProductResource = "digital_product_resource", i.CalendarHostAvatar = "calendar_host_avatar", i.FileManager = "file_manager", i.WhiteLabel = "white_label", i))(G || {}), X = /* @__PURE__ */ ((i) => (i.Image = "image", i.ImageOther = "image_other", i.Video = "video", i.Audio = "audio", i.Font = "font", i.Document = "document", i))(X || {});
const Oa = (i) => {
  if (typeof i != "object" || i === null) return !1;
  const e = i;
  return typeof e.id == "number" && typeof e.name == "string" && typeof e.filename == "string" && typeof e.path == "string" && (typeof e.thumbnail == "string" || e.thumbnail === null) && Object.values(G).includes(e.source) && typeof e.size == "number" && Object.values(X).includes(e.type) && typeof e.createdAt == "string";
}, Ea = {
  [G.Editor]: "file_manager.file_source.editor",
  [G.Community]: "file_manager.file_source.community",
  [G.BlockPreview]: "file_manager.file_source.block_preview",
  [G.Membership]: "file_manager.file_source.membership",
  [G.Marketplace]: "file_manager.file_source.marketplace",
  [G.Settings]: "file_manager.file_source.settings",
  [G.Email]: "file_manager.file_source.email",
  [G.Ckeditor]: "file_manager.file_source.ckeditor",
  [G.BlogPost]: "file_manager.file_source.blog_post",
  [G.PageTemplate]: "file_manager.file_source.page_template",
  [G.PageTemplatePreview]: "file_manager.file_source.page_template_preview",
  [G.BlogTemplatePreview]: "file_manager.file_source.blog_template_preview",
  [G.EmailTemplate]: "file_manager.file_source.email_template",
  [G.Product]: "file_manager.file_source.product",
  [G.FunnelTemplatePreview]: "file_manager.file_source.funnel_template_preview",
  [G.DigitalStore]: "file_manager.file_source.digital_store",
  [G.DigitalProductResource]: "file_manager.file_source.digital_product_resource",
  [G.CalendarHostAvatar]: "file_manager.file_source.calendar_host_avatar",
  [G.FileManager]: "file_manager.file_source.file_manager",
  [G.TextEditor]: "file_manager.file_source.text_editor",
  [G.WhiteLabel]: "file_manager.file_source.white_label",
  [G.WebsiteTemplate]: "file_manager.file_source.website_template"
}, Na = {
  [X.Image]: "file_manager.file_type.image",
  [X.ImageOther]: "file_manager.file_type.image_other",
  [X.Video]: "file_manager.file_type.video",
  [X.Audio]: "file_manager.file_type.audio",
  [X.Font]: "file_manager.file_type.font",
  [X.Document]: "file_manager.file_type.document"
};
var mr = /* @__PURE__ */ ((i) => (i.Next = "next", i.Prev = "prev", i))(mr || {}), Vs = /* @__PURE__ */ ((i) => (i.Asc = "ASC", i.Desc = "DESC", i))(Vs || {});
function _a(i) {
  return /* @__PURE__ */ b(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: /* @__PURE__ */ b("g", { id: "_x35_3", children: /* @__PURE__ */ b("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function jr(i) {
  return /* @__PURE__ */ j(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...i,
      children: [
        /* @__PURE__ */ b("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ b("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function Ra(i) {
  return /* @__PURE__ */ j(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...i,
      children: [
        /* @__PURE__ */ b("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ b("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function Pa(i) {
  return /* @__PURE__ */ j(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...i,
      children: [
        /* @__PURE__ */ b("g", { children: /* @__PURE__ */ b("g", { children: /* @__PURE__ */ b("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ b("g", { children: /* @__PURE__ */ b("g", { children: /* @__PURE__ */ b("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {}),
        /* @__PURE__ */ b("g", {})
      ]
    }
  );
}
function Da(i) {
  switch (i) {
    case X.Audio:
      return /* @__PURE__ */ b(_a, { className: "fill-text-secondary", width: 40, height: 40 });
    case X.Image:
    case X.ImageOther:
      return /* @__PURE__ */ b(Ra, { className: "fill-text-secondary", width: 40, height: 40 });
    case X.Video:
      return /* @__PURE__ */ b(Pa, { className: "fill-text-secondary", width: 40, height: 40 });
    case X.Font:
    case X.Document:
      return /* @__PURE__ */ b(jr, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ b(jr, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const Mt = /* @__PURE__ */ new Set(), Tt = /* @__PURE__ */ new Set(), ot = Oe.memo(
  ({
    src: i,
    fileType: e,
    alt: t,
    className: r,
    isThumbnail: s = !1,
    width: n,
    height: a,
    title: o
  }) => {
    const [l, c] = Oe.useState(Tt.has(i)), [u, d] = Oe.useState(Mt.has(i));
    return /* @__PURE__ */ j(
      "div",
      {
        className: ie("flex items-center justify-center", r),
        style: {
          width: n,
          height: a,
          minHeight: a
        },
        title: o,
        children: [
          e !== X.Video && /* @__PURE__ */ b(
            "img",
            {
              src: i,
              alt: t,
              className: ie(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoad: () => {
                d(!0), Mt.add(i), Tt.delete(i);
              },
              onError: () => {
                c(!0), Mt.delete(i), Tt.add(i);
              }
            }
          ),
          e === X.Video && /* @__PURE__ */ b(
            "video",
            {
              src: i,
              className: ie(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoadedData: () => {
                d(!0), Mt.add(i), Tt.delete(i);
              },
              onError: () => {
                c(!0), Mt.delete(i), Tt.add(i);
              },
              controls: !s
            }
          ),
          /* @__PURE__ */ b(
            "div",
            {
              className: ie(
                "flex-2 flex items-center justify-center rounded-md",
                !s && "min-h-[300px]",
                !i || l ? "flex" : "hidden"
              ),
              children: Da(e)
            }
          )
        ]
      }
    );
  }
);
ot.displayName = "FilePreview";
function Fa({
  fileType: i,
  src: e,
  alt: t,
  name: r,
  secondaryText: s,
  style: n,
  selected: a,
  actionMenu: o,
  className: l,
  imageWidth: c,
  imageHeight: u,
  onSelect: d
}) {
  const h = Oe.useRef(null), p = Oe.useRef(null);
  return /* @__PURE__ */ j(
    "div",
    {
      className: ie("relative flex flex-col cursor-pointer", l),
      style: n,
      onClick: (m) => {
        var v;
        h.current && !((v = p.current) != null && v.contains(m.target)) && h.current.click();
      },
      children: [
        /* @__PURE__ */ b(
          ot,
          {
            src: e ?? "",
            fileType: i,
            alt: t,
            width: c,
            height: u,
            className: ie(
              "relative -top-[2px] -left-[2px] flex-1 rounded-lg border-2 border-transparent box-content",
              a && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ b("div", { ref: p, className: "absolute top-1 left-1", children: /* @__PURE__ */ b(ea, { inputRef: h, value: a, onChange: d }) }),
        /* @__PURE__ */ b("div", { onClick: (m) => m.stopPropagation(), children: /* @__PURE__ */ b(
          ta,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...o,
            menuItems: (o == null ? void 0 : o.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ b(
          "div",
          {
            className: "truncate overflow-clip text-base text-text-primary mt-1",
            title: r,
            children: r
          }
        ),
        /* @__PURE__ */ b(
          "div",
          {
            className: "truncate overflow-clip text-sm text-text-secondary mt-1",
            title: s,
            children: s
          }
        )
      ]
    }
  );
}
const Ia = (i, e, t) => {
  const r = i[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((s, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, k = (i) => typeof i == "string", At = () => {
  let i, e;
  const t = new Promise((r, s) => {
    i = r, e = s;
  });
  return t.resolve = i, t.reject = e, t;
}, zr = (i) => i == null ? "" : "" + i, La = (i, e, t) => {
  i.forEach((r) => {
    e[r] && (t[r] = e[r]);
  });
}, ka = /###/g, Ur = (i) => i && i.indexOf("###") > -1 ? i.replace(ka, ".") : i, $r = (i) => !i || k(i), Ht = (i, e, t) => {
  const r = k(e) ? e.split(".") : e;
  let s = 0;
  for (; s < r.length - 1; ) {
    if ($r(i)) return {};
    const n = Ur(r[s]);
    !i[n] && t && (i[n] = new t()), Object.prototype.hasOwnProperty.call(i, n) ? i = i[n] : i = {}, ++s;
  }
  return $r(i) ? {} : {
    obj: i,
    k: Ur(r[s])
  };
}, Br = (i, e, t) => {
  const {
    obj: r,
    k: s
  } = Ht(i, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[s] = t;
    return;
  }
  let n = e[e.length - 1], a = e.slice(0, e.length - 1), o = Ht(i, a, Object);
  for (; o.obj === void 0 && a.length; )
    n = `${a[a.length - 1]}.${n}`, a = a.slice(0, a.length - 1), o = Ht(i, a, Object), o && o.obj && typeof o.obj[`${o.k}.${n}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${n}`] = t;
}, Ma = (i, e, t, r) => {
  const {
    obj: s,
    k: n
  } = Ht(i, e, Object);
  s[n] = s[n] || [], s[n].push(t);
}, hi = (i, e) => {
  const {
    obj: t,
    k: r
  } = Ht(i, e);
  if (t)
    return t[r];
}, Ta = (i, e, t) => {
  const r = hi(i, t);
  return r !== void 0 ? r : hi(e, t);
}, Ws = (i, e, t) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in i ? k(i[r]) || i[r] instanceof String || k(e[r]) || e[r] instanceof String ? t && (i[r] = e[r]) : Ws(i[r], e[r], t) : i[r] = e[r]);
  return i;
}, ut = (i) => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Aa = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const ja = (i) => k(i) ? i.replace(/[&<>"'\/]/g, (e) => Aa[e]) : i;
class za {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const Ua = [" ", ",", "?", "!", ";"], $a = new za(20), Ba = (i, e, t) => {
  e = e || "", t = t || "";
  const r = Ua.filter((a) => e.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (r.length === 0) return !0;
  const s = $a.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let n = !s.test(i);
  if (!n) {
    const a = i.indexOf(t);
    a > 0 && !s.test(i.substring(0, a)) && (n = !0);
  }
  return n;
}, ji = function(i, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!i) return;
  if (i[e]) return i[e];
  const r = e.split(t);
  let s = i;
  for (let n = 0; n < r.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = n; l < r.length; ++l)
      if (l !== n && (o += t), o += r[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < r.length - 1)
          continue;
        n += l - n + 1;
        break;
      }
    s = a;
  }
  return s;
}, di = (i) => i && i.replace("_", "-"), Ha = {
  type: "logger",
  log(i) {
    this.output("log", i);
  },
  warn(i) {
    this.output("warn", i);
  },
  error(i) {
    this.output("error", i);
  },
  output(i, e) {
    console && console[i] && console[i].apply(console, e);
  }
};
class fi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || Ha, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, r, s) {
    return s && !this.debug ? null : (k(e[0]) && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new fi(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new fi(this.logger, e);
  }
}
var ke = new fi();
class xi {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const s = this.observers[r].get(t) || 0;
      this.observers[r].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      r[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o.apply(o, [e, ...r]);
    });
  }
}
class Hr extends xi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const n = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, t], r && (Array.isArray(r) ? o.push(...r) : k(r) && n ? o.push(...r.split(n)) : o.push(r)));
    const l = hi(this.data, o);
    return !l && !t && !r && e.indexOf(".") > -1 && (e = o[0], t = o[1], r = o.slice(2).join(".")), l || !a || !k(r) ? l : ji(this.data && this.data[e] && this.data[e][t], r, n);
  }
  addResource(e, t, r, s) {
    let n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = [e, t];
    r && (o = o.concat(a ? r.split(a) : r)), e.indexOf(".") > -1 && (o = e.split("."), s = t, t = o[1]), this.addNamespaces(t), Br(this.data, o, s), n.silent || this.emit("added", e, t, r, s);
  }
  addResources(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const n in r)
      (k(r[n]) || Array.isArray(r[n])) && this.addResource(e, t, n, r[n], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, r);
  }
  addResourceBundle(e, t, r, s, n) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, t];
    e.indexOf(".") > -1 && (o = e.split("."), s = r, r = t, t = o[1]), this.addNamespaces(t);
    let l = hi(this.data, o) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), s ? Ws(l, r, n) : l = {
      ...l,
      ...r
    }, Br(this.data, o, l), a.silent || this.emit("added", e, t, r);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ks = {
  processors: {},
  addPostProcessor(i) {
    this.processors[i.name] = i;
  },
  handle(i, e, t, r, s) {
    return i.forEach((n) => {
      this.processors[n] && (e = this.processors[n].process(e, t, r, s));
    }), e;
  }
};
const Vr = {};
class pi extends xi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), La(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ke.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, t);
    return r && r.res !== void 0;
  }
  extractFromKey(e, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let n = t.ns || this.options.defaultNS || [];
    const a = r && e.indexOf(r) > -1, o = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Ba(e, r, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: k(n) ? [n] : n
        };
      const c = e.split(r);
      (r !== s || r === s && this.options.ns.indexOf(c[0]) > -1) && (n = c.shift()), e = c.join(s);
    }
    return {
      key: e,
      namespaces: k(n) ? [n] : n
    };
  }
  translate(e, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, n = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], t), l = o[o.length - 1], c = t.lng || this.language, u = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const N = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${N}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${N}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const d = this.resolve(e, t);
    let h = d && d.res;
    const p = d && d.usedKey || a, m = d && d.exactUsedKey || a, v = Object.prototype.toString.apply(h), y = ["[object Number]", "[object Function]", "[object RegExp]"], S = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, O = !this.i18nFormat || this.i18nFormat.handleAsObject, E = !k(h) && typeof h != "boolean" && typeof h != "number";
    if (O && h && E && y.indexOf(v) < 0 && !(k(S) && Array.isArray(h))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const N = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, h, {
          ...t,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (d.res = N, d.usedParams = this.getUsedParamsDetails(t), d) : N;
      }
      if (n) {
        const N = Array.isArray(h), R = N ? [] : {}, g = N ? m : p;
        for (const C in h)
          if (Object.prototype.hasOwnProperty.call(h, C)) {
            const w = `${g}${n}${C}`;
            R[C] = this.translate(w, {
              ...t,
              joinArrays: !1,
              ns: o
            }), R[C] === w && (R[C] = h[C]);
          }
        h = R;
      }
    } else if (O && k(S) && Array.isArray(h))
      h = h.join(S), h && (h = this.extendTranslation(h, e, t, r));
    else {
      let N = !1, R = !1;
      const g = t.count !== void 0 && !k(t.count), C = pi.hasDefaultValue(t), w = g ? this.pluralResolver.getSuffix(c, t.count, t) : "", x = t.ordinal && g ? this.pluralResolver.getSuffix(c, t.count, {
        ordinal: !1
      }) : "", _ = g && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), F = _ && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${w}`] || t[`defaultValue${x}`] || t.defaultValue;
      !this.isValidLookup(h) && C && (N = !0, h = F), this.isValidLookup(h) || (R = !0, h = a);
      const H = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && R ? void 0 : h, U = C && F !== h && this.options.updateMissing;
      if (R || N || U) {
        if (this.logger.log(U ? "updateKey" : "missingKey", c, l, a, U ? F : h), n) {
          const T = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          T && T.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Q = [];
        const M = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && M && M[0])
          for (let T = 0; T < M.length; T++)
            Q.push(M[T]);
        else this.options.saveMissingTo === "all" ? Q = this.languageUtils.toResolveHierarchy(t.lng || this.language) : Q.push(t.lng || this.language);
        const ae = (T, q, ee) => {
          const W = C && ee !== h ? ee : H;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(T, l, q, W, U, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(T, l, q, W, U, t), this.emit("missingKey", T, l, q, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && g ? Q.forEach((T) => {
          const q = this.pluralResolver.getSuffixes(T, t);
          _ && t[`defaultValue${this.options.pluralSeparator}zero`] && q.indexOf(`${this.options.pluralSeparator}zero`) < 0 && q.push(`${this.options.pluralSeparator}zero`), q.forEach((ee) => {
            ae([T], a + ee, t[`defaultValue${ee}`] || F);
          });
        }) : ae(Q, a, F));
      }
      h = this.extendTranslation(h, e, t, d, r), R && h === a && this.options.appendNamespaceToMissingKey && (h = `${l}:${a}`), (R || N) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, N ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return s ? (d.res = h, d.usedParams = this.getUsedParamsDetails(t), d) : h;
  }
  extendTranslation(e, t, r, s, n) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = k(e) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const h = e.match(this.interpolator.nestingRegexp);
        u = h && h.length;
      }
      let d = r.replace && !k(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, r.lng || this.language || s.usedLng, r), c) {
        const h = e.match(this.interpolator.nestingRegexp), p = h && h.length;
        u < p && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (r.lng = this.language || s.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var h = arguments.length, p = new Array(h), m = 0; m < h; m++)
          p[m] = arguments[m];
        return n && n[0] === p[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${p[0]} in key: ${t[0]}`), null) : a.translate(...p, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const o = r.postProcess || this.options.postProcess, l = k(o) ? [o] : o;
    return e != null && l && l.length && r.applyPostProcessor !== !1 && (e = Ks.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, n, a, o;
    return k(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(r)) return;
      const c = this.extractFromKey(l, t), u = c.key;
      s = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = t.count !== void 0 && !k(t.count), p = h && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = t.context !== void 0 && (k(t.context) || typeof t.context == "number") && t.context !== "", v = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((y) => {
        this.isValidLookup(r) || (o = y, !Vr[`${v[0]}-${y}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (Vr[`${v[0]}-${y}`] = !0, this.logger.warn(`key "${s}" for languages "${v.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), v.forEach((S) => {
          if (this.isValidLookup(r)) return;
          a = S;
          const O = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(O, u, S, y, t);
          else {
            let N;
            h && (N = this.pluralResolver.getSuffix(S, t.count, t));
            const R = `${this.options.pluralSeparator}zero`, g = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (O.push(u + N), t.ordinal && N.indexOf(g) === 0 && O.push(u + N.replace(g, this.options.pluralSeparator)), p && O.push(u + R)), m) {
              const C = `${u}${this.options.contextSeparator}${t.context}`;
              O.push(C), h && (O.push(C + N), t.ordinal && N.indexOf(g) === 0 && O.push(C + N.replace(g, this.options.pluralSeparator)), p && O.push(C + R));
            }
          }
          let E;
          for (; E = O.pop(); )
            this.isValidLookup(r) || (n = E, r = this.getResource(S, y, E, t));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: n,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, s) : this.resourceStore.getResource(e, t, r, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && !k(e.replace);
    let s = r ? e.replace : e;
    if (r && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !r) {
      s = {
        ...s
      };
      for (const n of t)
        delete s[n];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t === r.substring(0, t.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
const _i = (i) => i.charAt(0).toUpperCase() + i.slice(1);
class Wr {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ke.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = di(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = di(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (k(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s) return s;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((s) => s.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = _i(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = _i(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = _i(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((r) => {
      if (t) return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((r) => {
      if (t) return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s)) return t = s;
      t = this.options.supportedLngs.find((n) => {
        if (n === s) return n;
        if (!(n.indexOf("-") < 0 && s.indexOf("-") < 0) && (n.indexOf("-") > 0 && s.indexOf("-") < 0 && n.substring(0, n.indexOf("-")) === s || n.indexOf(s) === 0 && s.length > 1))
          return n;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), k(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let r = e[t];
    return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], n = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return k(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && n(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && n(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && n(this.getLanguagePartFromCode(e))) : k(e) && n(this.formatLanguageCode(e)), r.forEach((a) => {
      s.indexOf(a) < 0 && n(this.formatLanguageCode(a));
    }), s;
  }
}
let Va = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Wa = {
  1: (i) => +(i > 1),
  2: (i) => +(i != 1),
  3: (i) => 0,
  4: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  5: (i) => i == 0 ? 0 : i == 1 ? 1 : i == 2 ? 2 : i % 100 >= 3 && i % 100 <= 10 ? 3 : i % 100 >= 11 ? 4 : 5,
  6: (i) => i == 1 ? 0 : i >= 2 && i <= 4 ? 1 : 2,
  7: (i) => i == 1 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  8: (i) => i == 1 ? 0 : i == 2 ? 1 : i != 8 && i != 11 ? 2 : 3,
  9: (i) => +(i >= 2),
  10: (i) => i == 1 ? 0 : i == 2 ? 1 : i < 7 ? 2 : i < 11 ? 3 : 4,
  11: (i) => i == 1 || i == 11 ? 0 : i == 2 || i == 12 ? 1 : i > 2 && i < 20 ? 2 : 3,
  12: (i) => +(i % 10 != 1 || i % 100 == 11),
  13: (i) => +(i !== 0),
  14: (i) => i == 1 ? 0 : i == 2 ? 1 : i == 3 ? 2 : 3,
  15: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  16: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i !== 0 ? 1 : 2,
  17: (i) => i == 1 || i % 10 == 1 && i % 100 != 11 ? 0 : 1,
  18: (i) => i == 0 ? 0 : i == 1 ? 1 : 2,
  19: (i) => i == 1 ? 0 : i == 0 || i % 100 > 1 && i % 100 < 11 ? 1 : i % 100 > 10 && i % 100 < 20 ? 2 : 3,
  20: (i) => i == 1 ? 0 : i == 0 || i % 100 > 0 && i % 100 < 20 ? 1 : 2,
  21: (i) => i % 100 == 1 ? 1 : i % 100 == 2 ? 2 : i % 100 == 3 || i % 100 == 4 ? 3 : 0,
  22: (i) => i == 1 ? 0 : i == 2 ? 1 : (i < 0 || i > 10) && i % 10 == 0 ? 2 : 3
};
const Ka = ["v1", "v2", "v3"], Qa = ["v4"], Kr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, qa = () => {
  const i = {};
  return Va.forEach((e) => {
    e.lngs.forEach((t) => {
      i[t] = {
        numbers: e.nr,
        plurals: Wa[e.fc]
      };
    });
  }), i;
};
class Ya {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = ke.create("pluralResolver"), (!this.options.compatibilityJSON || Qa.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = qa(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = di(e === "dev" ? "en" : e), s = t.ordinal ? "ordinal" : "cardinal", n = JSON.stringify({
        cleanedCode: r,
        type: s
      });
      if (n in this.pluralRulesCache)
        return this.pluralRulesCache[n];
      let a;
      try {
        a = new Intl.PluralRules(r, {
          type: s
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, t);
      }
      return this.pluralRulesCache[n] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((s, n) => Kr[s] - Kr[n]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : r.numbers.map((s) => this.getSuffix(e, s, t)) : [];
  }
  getSuffix(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, r);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : this.getSuffixRetroCompatible(s, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let s = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const n = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : n() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? n() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Ka.includes(this.options.compatibilityJSON);
  }
}
const Qr = function(i, e, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, n = Ta(i, e, t);
  return !n && s && k(t) && (n = ji(i, t, r), n === void 0 && (n = ji(e, t, r))), n;
}, Ri = (i) => i.replace(/\$/g, "$$$$");
class Xa {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ke.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: r,
      useRawValueToEscape: s,
      prefix: n,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: p,
      nestingSuffix: m,
      nestingSuffixEscaped: v,
      nestingOptionsSeparator: y,
      maxReplaces: S,
      alwaysFormat: O
    } = e.interpolation;
    this.escape = t !== void 0 ? t : ja, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = n ? ut(n) : a || "{{", this.suffix = o ? ut(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? ut(h) : p || ut("$t("), this.nestingSuffix = m ? ut(m) : v || ut(")"), this.nestingOptionsSeparator = y || ",", this.maxReplaces = S || 1e3, this.alwaysFormat = O !== void 0 ? O : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, r) => t && t.source === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, r, s) {
    let n, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const S = Qr(t, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(S, void 0, r, {
          ...s,
          ...t,
          interpolationkey: p
        }) : S;
      }
      const m = p.split(this.formatSeparator), v = m.shift().trim(), y = m.join(this.formatSeparator).trim();
      return this.format(Qr(t, l, v, this.options.keySeparator, this.options.ignoreJSONStructure), y, r, {
        ...s,
        ...t,
        interpolationkey: v
      });
    };
    this.resetRegExp();
    const u = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, d = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => Ri(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? Ri(this.escape(p)) : Ri(p)
    }].forEach((p) => {
      for (o = 0; n = p.regex.exec(e); ) {
        const m = n[1].trim();
        if (a = c(m), a === void 0)
          if (typeof u == "function") {
            const y = u(e, n, s);
            a = k(y) ? y : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, m))
            a = "";
          else if (d) {
            a = n[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${e}`), a = "";
        else !k(a) && !this.useRawValueToEscape && (a = zr(a));
        const v = p.safeValue(a);
        if (e = e.replace(n[0], v), d ? (p.regex.lastIndex += a.length, p.regex.lastIndex -= n[0].length) : p.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, n, a;
    const o = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, a);
      const p = h.match(/'/g), m = h.match(/"/g);
      (p && p.length % 2 === 0 && !m || m.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        a = JSON.parse(h), c && (a = {
          ...c,
          ...a
        });
      } catch (v) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, v), `${l}${u}${h}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...r
      }, a = a.replace && !k(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const u = s[1].split(this.formatSeparator).map((d) => d.trim());
        s[1] = u.shift(), l = u, c = !0;
      }
      if (n = t(o.call(this, s[1].trim(), a), a), n && s[0] === e && !k(n)) return n;
      k(n) || (n = zr(n)), n || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), n = ""), c && (n = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: s[1].trim()
      }), n.trim())), e = e.replace(s[0], n), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Ga = (i) => {
  let e = i.toLowerCase().trim();
  const t = {};
  if (i.indexOf("(") > -1) {
    const r = i.split("(");
    e = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = o.trim();
        t[u] || (t[u] = c), c === "false" && (t[u] = !1), c === "true" && (t[u] = !0), isNaN(c) || (t[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, ht = (i) => {
  const e = {};
  return (t, r, s) => {
    let n = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (n = {
      ...n,
      [s.interpolationkey]: void 0
    });
    const a = r + JSON.stringify(n);
    let o = e[a];
    return o || (o = i(di(r), s), e[a] = o), o(t);
  };
};
class Ja {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ke.create("formatter"), this.options = e, this.formats = {
      number: ht((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      }),
      currency: ht((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (n) => s.format(n);
      }),
      datetime: ht((t, r) => {
        const s = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      }),
      relativetime: ht((t, r) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (n) => s.format(n, r.range || "day");
      }),
      list: ht((t, r) => {
        const s = new Intl.ListFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = ht(t);
  }
  format(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const n = t.split(this.formatSeparator);
    if (n.length > 1 && n[0].indexOf("(") > 1 && n[0].indexOf(")") < 0 && n.find((o) => o.indexOf(")") > -1)) {
      const o = n.findIndex((l) => l.indexOf(")") > -1);
      n[0] = [n[0], ...n.splice(1, o)].join(this.formatSeparator);
    }
    return n.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = Ga(l);
      if (this.formats[c]) {
        let d = o;
        try {
          const h = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, p = h.locale || h.lng || s.locale || s.lng || r;
          d = this.formats[c](o, p, {
            ...u,
            ...s,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const Za = (i, e) => {
  i.pending[e] !== void 0 && (delete i.pending[e], i.pendingCount--);
};
class eo extends xi {
  constructor(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = ke.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, s.backend, s);
  }
  queueLoad(e, t, r, s) {
    const n = {}, a = {}, o = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      t.forEach((d) => {
        const h = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? a[h] === void 0 && (a[h] = !0) : (this.state[h] = 1, u = !1, a[h] === void 0 && (a[h] = !0), n[h] === void 0 && (n[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (o[c] = !0);
    }), (Object.keys(n).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(n),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, r) {
    const s = e.split("|"), n = s[0], a = s[1];
    t && this.emit("failedLoading", n, a, t), !t && r && this.store.addResourceBundle(n, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && r && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      Ma(l.loaded, [n], a), Za(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          o[c][d] === void 0 && (o[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: r,
        tried: s,
        wait: n,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, r, s + 1, n * 2, a);
        }, n);
        return;
      }
      a(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((u) => o(null, u)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(e, t, o);
  }
  prepareLoading(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    k(e) && (e = this.languageUtils.toResolveHierarchy(e)), k(t) && (t = [t]);
    const n = this.queueLoad(e, t, r, s);
    if (!n.toLoad.length)
      return n.pending.length || s(), null;
    n.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, t, r) {
    this.prepareLoading(e, t, {}, r);
  }
  reload(e, t, r) {
    this.prepareLoading(e, t, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), s = r[0], n = r[1];
    this.read(s, n, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${t}loading namespace ${n} for language ${s} failed`, a), !a && o && this.logger.log(`${t}loaded namespace ${n} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, t, r, s, n) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: n
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, t, r, s, l) : u = c(e, t, r, s), u && typeof u.then == "function" ? u.then((d) => o(null, d)).catch(o) : o(null, u);
          } catch (u) {
            o(u);
          }
        else
          c(e, t, r, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, r, s);
    }
  }
}
const qr = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (i) => {
    let e = {};
    if (typeof i[1] == "object" && (e = i[1]), k(i[1]) && (e.defaultValue = i[1]), k(i[2]) && (e.tDescription = i[2]), typeof i[2] == "object" || typeof i[3] == "object") {
      const t = i[3] || i[2];
      Object.keys(t).forEach((r) => {
        e[r] = t[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (i) => i,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Yr = (i) => (k(i.ns) && (i.ns = [i.ns]), k(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]), k(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]), i.supportedLngs && i.supportedLngs.indexOf("cimode") < 0 && (i.supportedLngs = i.supportedLngs.concat(["cimode"])), i), ai = () => {
}, to = (i) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach((t) => {
    typeof i[t] == "function" && (i[t] = i[t].bind(i));
  });
};
class Wt extends xi {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Yr(e), this.services = {}, this.logger = ke, this.modules = {
      external: []
    }, to(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (k(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = qr();
    this.options = {
      ...s,
      ...this.options,
      ...Yr(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? ke.init(n(this.modules.logger), this.options) : ke.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = Ja);
      const d = new Wr(this.options);
      this.store = new Hr(this.options.resources, this.options);
      const h = this.services;
      h.logger = ke, h.resourceStore = this.store, h.languageUtils = d, h.pluralResolver = new Ya(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (h.formatter = n(u), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new Xa(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new eo(n(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(p) {
        for (var m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          v[y - 1] = arguments[y];
        e.emit(p, ...v);
      }), this.modules.languageDetector && (h.languageDetector = n(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = n(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new pi(this.services, this.options), this.translator.on("*", function(p) {
        for (var m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          v[y - 1] = arguments[y];
        e.emit(p, ...v);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = ai), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = At(), c = () => {
      const u = (d, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), r(d, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ai;
    const s = k(e) ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const n = [], a = (o) => {
        if (!o || o === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && n.indexOf(c) < 0 && n.push(c);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(n, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(o);
      });
    } else
      r(null);
  }
  reloadResources(e, t, r) {
    const s = At();
    return typeof e == "function" && (r = e, e = void 0), typeof t == "function" && (r = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), r || (r = ai), this.services.backendConnector.reload(e, t, (n) => {
      s.resolve(), r(n);
    }), s;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Ks.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var r = this;
    this.isLanguageChangingTo = e;
    const s = At();
    this.emit("languageChanging", e);
    const n = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? (n(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), t && t(l, function() {
        return r.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = k(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        a(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, t, r) {
    var s = this;
    const n = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(u));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || n.keyPrefix);
      const h = s.options.keySeparator || ".";
      let p;
      return l.keyPrefix && Array.isArray(a) ? p = a.map((m) => `${l.keyPrefix}${h}${m}`) : p = l.keyPrefix ? `${l.keyPrefix}${h}${a}` : a, s.t(p, l);
    };
    return k(e) ? n.lng = e : n.lngs = e, n.ns = t, n.keyPrefix = r, n;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, n = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const a = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const o = t.precheck(this, a);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, e) && (!s || a(n, e)));
  }
  loadNamespaces(e, t) {
    const r = At();
    return this.options.ns ? (k(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), t && t(s);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const r = At();
    k(e) && (e = [e]);
    const s = this.options.preload || [], n = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return n.length ? (this.options.preload = s.concat(n), this.loadResources((a) => {
      r.resolve(), t && t(a);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Wr(qr());
    return t.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Wt(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ai;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, n = new Wt(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (n.logger = n.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      n[o] = this[o];
    }), n.services = {
      ...this.services
    }, n.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, r && (n.store = new Hr(this.store.data, s), n.services.resourceStore = n.store), n.translator = new pi(n.services, s), n.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      n.emit(o, ...c);
    }), n.init(s, t), n.translator.options = s, n.translator.backendConnector.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, n;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const re = Wt.createInstance();
re.createInstance = Wt.createInstance;
re.createInstance;
re.dir;
re.init;
re.loadResources;
re.reloadResources;
re.use;
re.changeLanguage;
re.getFixedT;
const io = re.t;
re.exists;
re.setDefaultNamespace;
re.hasLoadedNamespace;
re.loadNamespaces;
re.loadLanguages;
function Kt(i) {
  "@babel/helpers - typeof";
  return Kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kt(i);
}
function ro(i, e) {
  if (Kt(i) != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(i, e);
    if (Kt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function Qs(i) {
  var e = ro(i, "string");
  return Kt(e) == "symbol" ? e : e + "";
}
function qs(i, e, t) {
  return (e = Qs(e)) in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function so(i, e) {
  if (!(i instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function no(i, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, Qs(r.key), r);
  }
}
function ao(i, e, t) {
  return e && no(i.prototype, e), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
var oo = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, lo = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, co = function(e) {
  return lo[e];
}, uo = function(e) {
  return e.replace(oo, co);
};
function Xr(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Gr(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xr(Object(t), !0).forEach(function(r) {
      qs(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : Xr(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
var zi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: uo
}, Ys, ho = Hs();
function fo() {
  var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  zi = Gr(Gr({}, zi), i);
}
function po() {
  return zi;
}
var mo = (function() {
  function i() {
    so(this, i), this.usedNamespaces = {};
  }
  return ao(i, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var r = this;
      t.forEach(function(s) {
        r.usedNamespaces[s] || (r.usedNamespaces[s] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), i;
})();
function go(i) {
  Ys = i;
}
function vo() {
  return Ys;
}
var yo = {
  type: "3rdParty",
  init: function(e) {
    fo(e.options.react), go(e);
  }
};
function bo() {
  if (console && console.warn) {
    for (var i, e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    typeof t[0] == "string" && (t[0] = "react-i18next:: ".concat(t[0])), (i = console).warn.apply(i, t);
  }
}
var Jr = {};
function Ui() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  typeof e[0] == "string" && Jr[e[0]] || (typeof e[0] == "string" && (Jr[e[0]] = /* @__PURE__ */ new Date()), bo.apply(void 0, e));
}
function Zr(i, e, t) {
  i.loadNamespaces(e, function() {
    if (i.isInitialized)
      t();
    else {
      var r = function s() {
        setTimeout(function() {
          i.off("initialized", s);
        }, 0), t();
      };
      i.on("initialized", r);
    }
  });
}
function wo(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = e.languages[0], s = e.options ? e.options.fallbackLng : !1, n = e.languages[e.languages.length - 1];
  if (r.toLowerCase() === "cimode") return !0;
  var a = function(l, c) {
    var u = e.services.backendConnector.state["".concat(l, "|").concat(c)];
    return u === -1 || u === 2;
  };
  return t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !a(e.isLanguageChangingTo, i) ? !1 : !!(e.hasResourceBundle(r, i) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || a(r, i) && (!s || a(n, i)));
}
function xo(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return Ui("i18n.languages were undefined or empty", e.languages), !0;
  var r = e.options.ignoreJSONStructure !== void 0;
  return r ? e.hasLoadedNamespace(i, {
    precheck: function(n, a) {
      if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !a(n.isLanguageChangingTo, i)) return !1;
    }
  }) : wo(i, e, t);
}
function Co(i) {
  if (Array.isArray(i)) return i;
}
function So(i, e) {
  var t = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (t != null) {
    var r, s, n, a, o = [], l = !0, c = !1;
    try {
      if (n = (t = t.call(i)).next, e !== 0) for (; !(l = (r = n.call(t)).done) && (o.push(r.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, s = u;
    } finally {
      try {
        if (!l && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw s;
      }
    }
    return o;
  }
}
function es(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = i[t];
  return r;
}
function Oo(i, e) {
  if (i) {
    if (typeof i == "string") return es(i, e);
    var t = {}.toString.call(i).slice(8, -1);
    return t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set" ? Array.from(i) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? es(i, e) : void 0;
  }
}
function Eo() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function No(i, e) {
  return Co(i) || So(i, e) || Oo(i, e) || Eo();
}
function ts(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Pi(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ts(Object(t), !0).forEach(function(r) {
      qs(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : ts(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
var _o = function(e, t) {
  var r = we();
  return Ee(function() {
    r.current = e;
  }, [e, t]), r.current;
};
function Ro(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.i18n, r = la(ho) || {}, s = r.i18n, n = r.defaultNS, a = t || s || vo();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new mo()), !a) {
    Ui("You will need to pass in an i18next instance by using initReactI18next");
    var o = function(x) {
      return Array.isArray(x) ? x[x.length - 1] : x;
    }, l = [o, {}, !1];
    return l.t = o, l.i18n = {}, l.ready = !1, l;
  }
  a.options.react && a.options.react.wait !== void 0 && Ui("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = Pi(Pi(Pi({}, po()), a.options.react), e), u = c.useSuspense, d = c.keyPrefix, h = i || n || a.options && a.options.defaultNS;
  h = typeof h == "string" ? [h] : h || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(h);
  var p = (a.isInitialized || a.initializedStoreOnce) && h.every(function(w) {
    return xo(w, a, c);
  });
  function m() {
    return a.getFixedT(null, c.nsMode === "fallback" ? h : h[0], d);
  }
  var v = V(m), y = No(v, 2), S = y[0], O = y[1], E = h.join(), N = _o(E), R = we(!0);
  Ee(function() {
    var w = c.bindI18n, x = c.bindI18nStore;
    R.current = !0, !p && !u && Zr(a, h, function() {
      R.current && O(m);
    }), p && N && N !== E && R.current && O(m);
    function _() {
      R.current && O(m);
    }
    return w && a && a.on(w, _), x && a && a.store.on(x, _), function() {
      R.current = !1, w && a && w.split(" ").forEach(function(F) {
        return a.off(F, _);
      }), x && a && x.split(" ").forEach(function(F) {
        return a.store.off(F, _);
      });
    };
  }, [a, E]);
  var g = we(!0);
  Ee(function() {
    R.current && !g.current && O(m), g.current = !1;
  }, [a, d]);
  var C = [S, a, p];
  if (C.t = S, C.i18n = a, C.ready = p, p || !p && !u) return C;
  throw new Promise(function(w) {
    Zr(a, h, function() {
      w();
    });
  });
}
const Xs = { title: "File Manager", file_upload: { file_not_supported: "File type not supported", drop_files_here: "Drag and drop your files here, or click to browse", upload_files: "Upload files", uploaded_successfully: "Successfully uploaded", crop_file: "Crop image ", crop_and_select_file: "Crop and select an image", upload_and_select_file: "Upload and select" }, cancelled: "Cancelled", error: "Error", something_went_wrong: "Something went wrong", confirm_action: "Confirm action", confirm: "Confirm", cancel: "Cancel", file_details: "File details", download: "Download", rename: "Rename", delete: "Delete", name: "Name", size: "Size", file_source: { editor: "Editor", community: "Community", block_preview: "Block preview", membership: "Membership", marketplace: "Marketplace", settings: "Settings", email: "Email", ckeditor: "CKEditor", blog_post: "Blog post", page_template: "Page template", page_template_preview: "Page template preview", blog_template_preview: "Blog template preview", email_template: "Email template", product: "Product", funnel_template_preview: "Funnel template preview", digital_store: "Creator store", digital_product_resource: "Digital product resource", file_manager: "File manager", calendar_host_avatar: "Calendar", text_editor: "Text editor", website_template: "Website template", white_label: "White Label" }, file_type: { image: "Image", image_other: "Other image", video: "Video", audio: "Audio", font: "Font", document: "Document" }, select: "Select", file_selector: { files_selected: "file selected", search_file: "Search file", rename_file: "Rename file", file_name: "File name", enter_new_file_name: "Enter a new file name", failed_rename_file: "Failed to rename file", failed_delete_file: "Failed to delete file", failed_download_file: "Failed to download file", file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?', choose_file: "Choose a file" }, search: "Search", upload: "Upload", file: "File", select_type: "Select file type", select_source: "Select source", type: "Type", created_at: "Created at", processing_size: "Processing", preview: "Preview", image_cropper: { aspect_ratio: { need_to_crop: "Crop image before selecting", need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one" } }, errors: { payload_to_large_error_message: "The file size is too big", conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!", fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue", internal_error_message: "Something went wrong. Please try again" }, file_renamed_successfully: "Renamed successfully", file_deleted_successfully: "Deleted successfully" }, Gs = {
  file_manager: Xs
}, Po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gs,
  file_manager: Xs
}, Symbol.toStringTag, { value: "Module" })), Ci = ["common"], gr = Ci[0], Do = Object.values(Ai), Fo = {
  en: { common: Gs }
}, Io = {
  supportedLngs: Do,
  load: "languageOnly",
  debug: !1,
  defaultNS: gr,
  react: { useSuspense: !1 },
  ns: Ci,
  fallbackLng: Ai.ENGLISH,
  lng: Ai.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Fo,
  returnEmptyString: !1
};
re.use(yo).init(Io);
const Lo = async (i) => {
  const e = await Ia(/* @__PURE__ */ Object.assign({ "./assets/translations/locales/ar/common.json": () => import("./common-DMCV0GGi.mjs"), "./assets/translations/locales/bn/common.json": () => import("./common-BM-3M8Dx.mjs"), "./assets/translations/locales/cs/common.json": () => import("./common-DZRWiEBT.mjs"), "./assets/translations/locales/da/common.json": () => import("./common-DelsybBV.mjs"), "./assets/translations/locales/de/common.json": () => import("./common-BXcmwsrd.mjs"), "./assets/translations/locales/el/common.json": () => import("./common-BjwpuYro.mjs"), "./assets/translations/locales/en/common.json": () => Promise.resolve().then(() => Po), "./assets/translations/locales/es/common.json": () => import("./common-B_szy-FP.mjs"), "./assets/translations/locales/fi/common.json": () => import("./common-C4LoSUJq.mjs"), "./assets/translations/locales/fr/common.json": () => import("./common-CYTvzuJ6.mjs"), "./assets/translations/locales/he/common.json": () => import("./common-CmMEn3dp.mjs"), "./assets/translations/locales/hi/common.json": () => import("./common-DUSyIfC_.mjs"), "./assets/translations/locales/hu/common.json": () => import("./common-WLsuBVdv.mjs"), "./assets/translations/locales/id/common.json": () => import("./common-CsMC8nWS.mjs"), "./assets/translations/locales/it/common.json": () => import("./common-ga7QJLpV.mjs"), "./assets/translations/locales/ja/common.json": () => import("./common-uzhy7A-q.mjs"), "./assets/translations/locales/ms/common.json": () => import("./common-BWiHUpD2.mjs"), "./assets/translations/locales/nl/common.json": () => import("./common-wSFMKGJB.mjs"), "./assets/translations/locales/no/common.json": () => import("./common-DAhW0tn5.mjs"), "./assets/translations/locales/pl/common.json": () => import("./common-DPWUnqdR.mjs"), "./assets/translations/locales/pt/common.json": () => import("./common-CNGRVbtk.mjs"), "./assets/translations/locales/ro/common.json": () => import("./common-DMnHVhgK.mjs"), "./assets/translations/locales/ru/common.json": () => import("./common-BDPRVMtQ.mjs"), "./assets/translations/locales/sk/common.json": () => import("./common-DXN70-fE.mjs"), "./assets/translations/locales/sl/common.json": () => import("./common-Bfz7QYTV.mjs"), "./assets/translations/locales/sq/common.json": () => import("./common-BYN6oIio.mjs"), "./assets/translations/locales/sr/common.json": () => import("./common-olVGXe6V.mjs"), "./assets/translations/locales/sv/common.json": () => import("./common-Cc7H2ooY.mjs"), "./assets/translations/locales/th/common.json": () => import("./common-DjabKxhc.mjs"), "./assets/translations/locales/tl/common.json": () => import("./common-Bu0NYLN8.mjs"), "./assets/translations/locales/tr/common.json": () => import("./common-Do1M5XIB.mjs"), "./assets/translations/locales/uk/common.json": () => import("./common-Bdag_9uX.mjs"), "./assets/translations/locales/zh/common.json": () => import("./common-Cl6I1s17.mjs") }), `./assets/translations/locales/${i}/common.json`, 6);
  return re.addResourceBundle(i, gr, {
    file_manager: e.default.file_manager
  }), e;
}, Js = () => Ci, Zs = (i) => i.startsWith("core.error.") ? i.replace("core.error.", "file_manager.errors.") : i.replace(/^(global\.|core\.)/g, "file_manager."), en = ya(io, Js, Zs), pe = ba({
  useTranslation: Ro,
  defaultNamespaces: Ci,
  namespaceMapper: Js,
  assetKeyMapper: Zs
}), vr = wa(), vt = xa({
  httpClient: vr,
  useLocoTranslation: pe,
  useRouter: () => ({
    push: async (i) => (window.location.assign(i), !0),
    replace: async (i) => (window.location.replace(i), !0)
  })
});
function ko(i, e = 2, t) {
  if (i < 0) return (t == null ? void 0 : t.whenNegative) ?? en("file_manager.processing_size");
  if (i === 0) return "0 Bytes";
  const r = 1024, s = e < 0 ? 0 : e, n = ["Bytes", "KB", "MB", "GB"], a = Math.floor(Math.log(i) / Math.log(r));
  return parseFloat((i / Math.pow(r, a)).toFixed(s)) + " " + n[a];
}
const Mo = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif"];
function $i(i) {
  var t;
  const e = (t = i.name.split(".").pop()) == null ? void 0 : t.toLowerCase();
  return i.type.startsWith("image/") || Mo.includes(e ?? "-");
}
async function tn(i) {
  return new Promise((e, t) => {
    const r = new Image();
    r.src = i, r.crossOrigin = "Anonymous", r.onload = () => {
      const s = r.width / r.height;
      e([r, s]);
    }, r.onerror = (s) => {
      t(new Error("Failed to load image"));
    };
  });
}
function rn(i, e, t = 0.02) {
  return Math.abs(i - e) < t;
}
function sn(i, e = 0.02) {
  const r = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((s) => Math.abs(i - s.value) < e);
  return r == null ? void 0 : r.label;
}
function To(i, e = 0.02) {
  const t = sn(i, e);
  let r = en("file_manager.image_cropper.aspect_ratio.need_to_crop");
  return t && (r += ` ${t}`), r;
}
function is(i, e) {
  if (!e || isNaN(e))
    return i;
  const t = sn(e);
  if (!t)
    return i;
  const r = t.replace(/[\s:]+/g, "_"), s = i.name.split(".").pop(), a = `${i.name.replace(/\.[^.]+$/, "")}_${r}.${s}`;
  return new File([i], a, {
    type: i.type,
    lastModified: i.lastModified
  });
}
function Ao(i, e) {
  return {
    id: i.id,
    name: i.filename,
    filename: i.filename,
    path: i.path,
    thumbnail: i.thumbnail || null,
    source: e,
    size: i.size,
    type: i.type,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
async function jo(i, e, t = "image/png") {
  const r = new OffscreenCanvas(i.width, i.height), s = r.getContext("2d");
  if (!s) throw new Error("Canvas context is not available");
  s.drawImage(i, 0, 0);
  const n = await r.convertToBlob({ type: t });
  return new File([n], e, { type: t });
}
function rs(i, e) {
  const t = we(null);
  Ee(() => {
    t.current !== null && e(t.current, i), t.current = i;
  }, [i]);
}
function ss(i, e) {
  return {
    added: e.filter((t) => !i.includes(t)),
    removed: i.filter((t) => !e.includes(t))
  };
}
async function zo(i) {
  const e = await i.arrayBuffer(), t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
function ns(i, e) {
  const s = `${i.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([e], s, {
    type: "image/png",
    lastModified: i.lastModified
  });
}
const mu = {
  image: ["image/*"],
  csv: ["text/csv", "application/vnd.ms-excel", "application/csv", ".csv"]
}, as = (i, e) => e.some((t) => {
  if (t.includes("*")) {
    const r = t.replace("*", ".*");
    return new RegExp(`^${r}$`).test(i);
  } else
    return i.toLowerCase() === t.toLowerCase();
}), Uo = (i) => i.join(", ");
function gu(i) {
  var l;
  const e = (l = i.split(".").pop()) == null ? void 0 : l.toLowerCase();
  if (!e) return X.Document;
  const t = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], r = ["tiff", "heic", "raw"], s = ["mp4", "mov", "avi", "mkv", "webm"], n = ["mp3", "wav", "ogg", "aac", "flac"], a = ["ttf", "otf", "woff", "woff2"], o = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
  return t.includes(e) ? X.Image : r.includes(e) ? X.ImageOther : s.includes(e) ? X.Video : n.includes(e) ? X.Audio : a.includes(e) ? X.Font : (o.includes(e), X.Document);
}
function $o({
  fileType: i,
  src: e,
  alt: t,
  name: r,
  size: s,
  className: n,
  onClose: a,
  showCloseButton: o = !0,
  isFetching: l
}) {
  const { t: c } = pe();
  return l ? /* @__PURE__ */ j("div", { className: ie("flex w-full flex-col items-end", n), children: [
    o && /* @__PURE__ */ b("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ b(Tr, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ j("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ b("div", { className: "bg-background-tertiary h-[300px] w-full animate-pulse rounded-md" }),
      /* @__PURE__ */ b("div", { className: "bg-background-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ b("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
      /* @__PURE__ */ b("div", { className: "bg-background-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ b("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
    ] })
  ] }) : /* @__PURE__ */ j("div", { className: ie("flex w-full flex-col items-end", n), children: [
    o && /* @__PURE__ */ b("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ b(Tr, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ j("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ b(ot, { src: e ?? "", fileType: i, alt: t }),
      r && /* @__PURE__ */ j(Ti, { children: [
        /* @__PURE__ */ b(
          "div",
          {
            className: "text-text-secondary mt-5 overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.name")
          }
        ),
        /* @__PURE__ */ b(
          "div",
          {
            className: "text-text-tertiary mt-2 truncate text-base font-semibold ",
            title: r,
            style: { lineHeight: 1.1 },
            children: r
          }
        )
      ] }),
      typeof s == "number" && /* @__PURE__ */ j(Ti, { children: [
        /* @__PURE__ */ b(
          "div",
          {
            className: "text-text-secondary mt-[10px] overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.size")
          }
        ),
        /* @__PURE__ */ b(
          "div",
          {
            className: "text-text-tertiary mt-2 text-base font-semibold",
            style: { lineHeight: 1.1 },
            children: ko(s)
          }
        )
      ] })
    ] })
  ] });
}
const nn = Oe.memo(({ file: i, className: e }) => i.type.startsWith("image/") ? /* @__PURE__ */ b(
  ot,
  {
    src: URL.createObjectURL(i),
    fileType: X.Image,
    alt: i.name,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
) : i.type === "application/pdf" ? /* @__PURE__ */ b(
  "div",
  {
    className: ie(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      e
    ),
    title: i.name,
    children: /* @__PURE__ */ b(
      "embed",
      {
        src: URL.createObjectURL(i),
        type: i.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : i.type.startsWith("video/") ? /* @__PURE__ */ b(
  ot,
  {
    src: URL.createObjectURL(i),
    fileType: X.Video,
    alt: i.name,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
) : /* @__PURE__ */ b(
  ot,
  {
    src: "",
    fileType: X.Document,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
));
nn.displayName = "FilePreviewFromOS";
function os({
  opened: i,
  onClose: e,
  onConfirm: t,
  onDecline: r,
  title: s,
  confirmationText: n = "",
  className: a,
  cancelButtonCaption: o,
  confirmButtonCaption: l,
  buttonClassName: c,
  buttonTextClassName: u,
  confirmationContent: d,
  afterLeave: h
}) {
  const { t: p } = pe(), [m, v] = V(""), [y, S] = V(!1), [O, E] = V(!1), N = async () => {
    try {
      S(!0), await t(), S(!1), E(!0);
    } catch {
      S(!1), v(p("file_manager.something_went_wrong"));
    }
  }, R = () => {
    v(""), E(!1);
  };
  return /* @__PURE__ */ b(
    bi,
    {
      opened: i,
      onClose: () => {
        !O && r && r(), e();
      },
      title: s || p("file_manager.confirm_action"),
      afterLeave: () => {
        h && h(), R();
      },
      isFetching: y,
      isCentered: !0,
      className: a,
      children: /* @__PURE__ */ j("form", { className: "flex flex-col gap-6 lg:gap-10", children: [
        n && /* @__PURE__ */ b("div", { className: "flex justify-center", children: /* @__PURE__ */ b("p", { className: "text-text-primary text-base", children: n }) }),
        d,
        /* @__PURE__ */ j("div", { className: "flex justify-center gap-4", children: [
          /* @__PURE__ */ b(
            ti,
            {
              isFetching: y,
              className: ie("w-full", c),
              buttonTextClassName: u,
              width: "large",
              onClick: async (g) => {
                g.preventDefault(), await N();
              },
              type: "submit",
              children: l || p("file_manager.confirm")
            }
          ),
          /* @__PURE__ */ b(
            Bs,
            {
              className: ie("w-full", c),
              width: "large",
              buttonTextClassName: u,
              onClick: (g) => {
                g.preventDefault(), r && r(), e();
              },
              disabled: y,
              children: o || p("file_manager.cancel")
            }
          )
        ] }),
        /* @__PURE__ */ b(ui, { error: m, errorClassName: "text-center" })
      ] })
    }
  );
}
function Bo({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ b(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ j("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ b(
          da,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.file_details")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function Ho({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ b(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ j("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ b(
          fa,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.delete")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function Vo({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ b(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ j("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ b(
          pa,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.rename")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function Wo({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ b(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ j("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ b(
          ma,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.download")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
var ii = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(i) {
    return this.listeners.add(i), this.onSubscribe(), () => {
      this.listeners.delete(i), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, lt = typeof window > "u" || "Deno" in globalThis;
function Se() {
}
function Ko(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function Bi(i) {
  return typeof i == "number" && i >= 0 && i !== 1 / 0;
}
function an(i, e) {
  return Math.max(i + (e || 0) - Date.now(), 0);
}
function yt(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function Pe(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function ls(i, e) {
  const {
    type: t = "all",
    exact: r,
    fetchStatus: s,
    predicate: n,
    queryKey: a,
    stale: o
  } = i;
  if (a) {
    if (r) {
      if (e.queryHash !== yr(a, e.options))
        return !1;
    } else if (!qt(e.queryKey, a))
      return !1;
  }
  if (t !== "all") {
    const l = e.isActive();
    if (t === "active" && !l || t === "inactive" && l)
      return !1;
  }
  return !(typeof o == "boolean" && e.isStale() !== o || s && s !== e.state.fetchStatus || n && !n(e));
}
function cs(i, e) {
  const { exact: t, status: r, predicate: s, mutationKey: n } = i;
  if (n) {
    if (!e.options.mutationKey)
      return !1;
    if (t) {
      if (Qt(e.options.mutationKey) !== Qt(n))
        return !1;
    } else if (!qt(e.options.mutationKey, n))
      return !1;
  }
  return !(r && e.state.status !== r || s && !s(e));
}
function yr(i, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Qt)(i);
}
function Qt(i) {
  return JSON.stringify(
    i,
    (e, t) => Wi(t) ? Object.keys(t).sort().reduce((r, s) => (r[s] = t[s], r), {}) : t
  );
}
function qt(i, e) {
  return i === e ? !0 : typeof i != typeof e ? !1 : i && e && typeof i == "object" && typeof e == "object" ? !Object.keys(e).some((t) => !qt(i[t], e[t])) : !1;
}
function Hi(i, e) {
  if (i === e)
    return i;
  const t = us(i) && us(e);
  if (t || Wi(i) && Wi(e)) {
    const r = t ? i : Object.keys(i), s = r.length, n = t ? e : Object.keys(e), a = n.length, o = t ? [] : {};
    let l = 0;
    for (let c = 0; c < a; c++) {
      const u = t ? c : n[c];
      (!t && r.includes(u) || t) && i[u] === void 0 && e[u] === void 0 ? (o[u] = void 0, l++) : (o[u] = Hi(i[u], e[u]), o[u] === i[u] && i[u] !== void 0 && l++);
    }
    return s === a && l === s ? i : o;
  }
  return e;
}
function Vi(i, e) {
  if (!e || Object.keys(i).length !== Object.keys(e).length)
    return !1;
  for (const t in i)
    if (i[t] !== e[t])
      return !1;
  return !0;
}
function us(i) {
  return Array.isArray(i) && i.length === Object.keys(i).length;
}
function Wi(i) {
  if (!hs(i))
    return !1;
  const e = i.constructor;
  if (e === void 0)
    return !0;
  const t = e.prototype;
  return !(!hs(t) || !t.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(i) !== Object.prototype);
}
function hs(i) {
  return Object.prototype.toString.call(i) === "[object Object]";
}
function Qo(i) {
  return new Promise((e) => {
    setTimeout(e, i);
  });
}
function Ki(i, e, t) {
  if (typeof t.structuralSharing == "function")
    return t.structuralSharing(i, e);
  if (t.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Hi(i, e);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${t.queryHash}]: ${r}`
        );
      }
    return Hi(i, e);
  }
  return e;
}
function qo(i, e, t = 0) {
  const r = [...i, e];
  return t && r.length > t ? r.slice(1) : r;
}
function Yo(i, e, t = 0) {
  const r = [e, ...i];
  return t && r.length > t ? r.slice(0, -1) : r;
}
var mi = Symbol();
function on(i, e) {
  return process.env.NODE_ENV !== "production" && i.queryFn === mi && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${i.queryHash}'`
  ), !i.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !i.queryFn || i.queryFn === mi ? () => Promise.reject(new Error(`Missing queryFn: '${i.queryHash}'`)) : i.queryFn;
}
var et, $e, xt, Ls, Xo = (Ls = class extends ii {
  constructor() {
    super();
    L(this, et);
    L(this, $e);
    L(this, xt);
    P(this, xt, (e) => {
      if (!lt && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    });
  }
  onSubscribe() {
    f(this, $e) || this.setEventListener(f(this, xt));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = f(this, $e)) == null || e.call(this), P(this, $e, void 0));
  }
  setEventListener(e) {
    var t;
    P(this, xt, e), (t = f(this, $e)) == null || t.call(this), P(this, $e, e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(e) {
    f(this, et) !== e && (P(this, et, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  isFocused() {
    var e;
    return typeof f(this, et) == "boolean" ? f(this, et) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, et = new WeakMap(), $e = new WeakMap(), xt = new WeakMap(), Ls), br = new Xo(), Ct, Be, St, ks, Go = (ks = class extends ii {
  constructor() {
    super();
    L(this, Ct, !0);
    L(this, Be);
    L(this, St);
    P(this, St, (e) => {
      if (!lt && window.addEventListener) {
        const t = () => e(!0), r = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    f(this, Be) || this.setEventListener(f(this, St));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = f(this, Be)) == null || e.call(this), P(this, Be, void 0));
  }
  setEventListener(e) {
    var t;
    P(this, St, e), (t = f(this, Be)) == null || t.call(this), P(this, Be, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    f(this, Ct) !== e && (P(this, Ct, e), this.listeners.forEach((r) => {
      r(e);
    }));
  }
  isOnline() {
    return f(this, Ct);
  }
}, Ct = new WeakMap(), Be = new WeakMap(), St = new WeakMap(), ks), gi = new Go();
function Qi() {
  let i, e;
  const t = new Promise((s, n) => {
    i = s, e = n;
  });
  t.status = "pending", t.catch(() => {
  });
  function r(s) {
    Object.assign(t, s), delete t.resolve, delete t.reject;
  }
  return t.resolve = (s) => {
    r({
      status: "fulfilled",
      value: s
    }), i(s);
  }, t.reject = (s) => {
    r({
      status: "rejected",
      reason: s
    }), e(s);
  }, t;
}
function Jo(i) {
  return Math.min(1e3 * 2 ** i, 3e4);
}
function ln(i) {
  return (i ?? "online") === "online" ? gi.isOnline() : !0;
}
var cn = class extends Error {
  constructor(i) {
    super("CancelledError"), this.revert = i == null ? void 0 : i.revert, this.silent = i == null ? void 0 : i.silent;
  }
};
function Di(i) {
  return i instanceof cn;
}
function un(i) {
  let e = !1, t = 0, r = !1, s;
  const n = Qi(), a = (v) => {
    var y;
    r || (h(new cn(v)), (y = i.abort) == null || y.call(i));
  }, o = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, c = () => br.isFocused() && (i.networkMode === "always" || gi.isOnline()) && i.canRun(), u = () => ln(i.networkMode) && i.canRun(), d = (v) => {
    var y;
    r || (r = !0, (y = i.onSuccess) == null || y.call(i, v), s == null || s(), n.resolve(v));
  }, h = (v) => {
    var y;
    r || (r = !0, (y = i.onError) == null || y.call(i, v), s == null || s(), n.reject(v));
  }, p = () => new Promise((v) => {
    var y;
    s = (S) => {
      (r || c()) && v(S);
    }, (y = i.onPause) == null || y.call(i);
  }).then(() => {
    var v;
    s = void 0, r || (v = i.onContinue) == null || v.call(i);
  }), m = () => {
    if (r)
      return;
    let v;
    const y = t === 0 ? i.initialPromise : void 0;
    try {
      v = y ?? i.fn();
    } catch (S) {
      v = Promise.reject(S);
    }
    Promise.resolve(v).then(d).catch((S) => {
      var g;
      if (r)
        return;
      const O = i.retry ?? (lt ? 0 : 3), E = i.retryDelay ?? Jo, N = typeof E == "function" ? E(t, S) : E, R = O === !0 || typeof O == "number" && t < O || typeof O == "function" && O(t, S);
      if (e || !R) {
        h(S);
        return;
      }
      t++, (g = i.onFail) == null || g.call(i, t, S), Qo(N).then(() => c() ? void 0 : p()).then(() => {
        e ? h(S) : m();
      });
    });
  };
  return {
    promise: n,
    cancel: a,
    continue: () => (s == null || s(), n),
    cancelRetry: o,
    continueRetry: l,
    canStart: u,
    start: () => (u() ? m() : p().then(m), n)
  };
}
function Zo() {
  let i = [], e = 0, t = (o) => {
    o();
  }, r = (o) => {
    o();
  }, s = (o) => setTimeout(o, 0);
  const n = (o) => {
    e ? i.push(o) : s(() => {
      t(o);
    });
  }, a = () => {
    const o = i;
    i = [], o.length && s(() => {
      r(() => {
        o.forEach((l) => {
          t(l);
        });
      });
    });
  };
  return {
    batch: (o) => {
      let l;
      e++;
      try {
        l = o();
      } finally {
        e--, e || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (o) => (...l) => {
      n(() => {
        o(...l);
      });
    },
    schedule: n,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (o) => {
      t = o;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (o) => {
      r = o;
    },
    setScheduler: (o) => {
      s = o;
    }
  };
}
var le = Zo(), tt, Ms, hn = (Ms = class {
  constructor() {
    L(this, tt);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Bi(this.gcTime) && P(this, tt, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(i) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      i ?? (lt ? 1 / 0 : 300 * 1e3)
    );
  }
  clearGcTimeout() {
    f(this, tt) && (clearTimeout(f(this, tt)), P(this, tt, void 0));
  }
}, tt = new WeakMap(), Ms), Ot, Et, Ce, ue, Gt, it, Re, Ae, Ts, el = (Ts = class extends hn {
  constructor(e) {
    super();
    L(this, Re);
    L(this, Ot);
    L(this, Et);
    L(this, Ce);
    L(this, ue);
    L(this, Gt);
    L(this, it);
    P(this, it, !1), P(this, Gt, e.defaultOptions), this.setOptions(e.options), this.observers = [], P(this, Ce, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, P(this, Ot, tl(this.options)), this.state = e.state ?? f(this, Ot), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = f(this, ue)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...f(this, Gt), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && f(this, Ce).remove(this);
  }
  setData(e, t) {
    const r = Ki(this.state.data, e, this.options);
    return $(this, Re, Ae).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: t == null ? void 0 : t.updatedAt,
      manual: t == null ? void 0 : t.manual
    }), r;
  }
  setState(e, t) {
    $(this, Re, Ae).call(this, { type: "setState", state: e, setStateOptions: t });
  }
  cancel(e) {
    var r, s;
    const t = (r = f(this, ue)) == null ? void 0 : r.promise;
    return (s = f(this, ue)) == null || s.cancel(e), t ? t.then(Se).catch(Se) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(f(this, Ot));
  }
  isActive() {
    return this.observers.some(
      (e) => Pe(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === mi || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !an(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var t;
    const e = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (t = f(this, ue)) == null || t.continue();
  }
  onOnline() {
    var t;
    const e = this.observers.find((r) => r.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (t = f(this, ue)) == null || t.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), f(this, Ce).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (f(this, ue) && (f(this, it) ? f(this, ue).cancel({ revert: !0 }) : f(this, ue).cancelRetry()), this.scheduleGc()), f(this, Ce).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || $(this, Re, Ae).call(this, { type: "invalidate" });
  }
  fetch(e, t) {
    var l, c, u;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (t != null && t.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (f(this, ue))
        return f(this, ue).continueRetry(), f(this, ue).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((h) => h.options.queryFn);
      d && this.setOptions(d.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), s = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => (P(this, it, !0), r.signal)
      });
    }, n = () => {
      const d = on(this.options, t), h = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return s(h), P(this, it, !1), this.options.persister ? this.options.persister(
        d,
        h,
        this
      ) : d(h);
    }, a = {
      fetchOptions: t,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: n
    };
    s(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), P(this, Et, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((c = a.fetchOptions) == null ? void 0 : c.meta)) && $(this, Re, Ae).call(this, { type: "fetch", meta: (u = a.fetchOptions) == null ? void 0 : u.meta });
    const o = (d) => {
      var h, p, m, v;
      Di(d) && d.silent || $(this, Re, Ae).call(this, {
        type: "error",
        error: d
      }), Di(d) || ((p = (h = f(this, Ce).config).onError) == null || p.call(
        h,
        d,
        this
      ), (v = (m = f(this, Ce).config).onSettled) == null || v.call(
        m,
        this.state.data,
        d,
        this
      )), this.scheduleGc();
    };
    return P(this, ue, un({
      initialPromise: t == null ? void 0 : t.initialPromise,
      fn: a.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (d) => {
        var h, p, m, v;
        if (d === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), o(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(d);
        } catch (y) {
          o(y);
          return;
        }
        (p = (h = f(this, Ce).config).onSuccess) == null || p.call(h, d, this), (v = (m = f(this, Ce).config).onSettled) == null || v.call(
          m,
          d,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: o,
      onFail: (d, h) => {
        $(this, Re, Ae).call(this, { type: "failed", failureCount: d, error: h });
      },
      onPause: () => {
        $(this, Re, Ae).call(this, { type: "pause" });
      },
      onContinue: () => {
        $(this, Re, Ae).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), f(this, ue).start();
  }
}, Ot = new WeakMap(), Et = new WeakMap(), Ce = new WeakMap(), ue = new WeakMap(), Gt = new WeakMap(), it = new WeakMap(), Re = new WeakSet(), Ae = function(e) {
  const t = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...dn(r.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: e.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const s = e.error;
        return Di(s) && s.revert && f(this, Et) ? { ...f(this, Et), fetchStatus: "idle" } : {
          ...r,
          error: s,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: s,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...e.state
        };
    }
  };
  this.state = t(this.state), le.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), f(this, Ce).notify({ query: this, type: "updated", action: e });
  });
}, Ts);
function dn(i, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: ln(e.networkMode) ? "fetching" : "paused",
    ...i === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function tl(i) {
  const e = typeof i.initialData == "function" ? i.initialData() : i.initialData, t = e !== void 0, r = t ? typeof i.initialDataUpdatedAt == "function" ? i.initialDataUpdatedAt() : i.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: t ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: t ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var De, As, il = (As = class extends ii {
  constructor(e = {}) {
    super();
    L(this, De);
    this.config = e, P(this, De, /* @__PURE__ */ new Map());
  }
  build(e, t, r) {
    const s = t.queryKey, n = t.queryHash ?? yr(s, t);
    let a = this.get(n);
    return a || (a = new el({
      cache: this,
      queryKey: s,
      queryHash: n,
      options: e.defaultQueryOptions(t),
      state: r,
      defaultOptions: e.getQueryDefaults(s)
    }), this.add(a)), a;
  }
  add(e) {
    f(this, De).has(e.queryHash) || (f(this, De).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = f(this, De).get(e.queryHash);
    t && (e.destroy(), t === e && f(this, De).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return f(this, De).get(e);
  }
  getAll() {
    return [...f(this, De).values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => ls(t, r)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((r) => ls(e, r)) : t;
  }
  notify(e) {
    le.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, De = new WeakMap(), As), Fe, de, rt, Ie, Ue, js, rl = (js = class extends hn {
  constructor(e) {
    super();
    L(this, Ie);
    L(this, Fe);
    L(this, de);
    L(this, rt);
    this.mutationId = e.mutationId, P(this, de, e.mutationCache), P(this, Fe, []), this.state = e.state || sl(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    f(this, Fe).includes(e) || (f(this, Fe).push(e), this.clearGcTimeout(), f(this, de).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    P(this, Fe, f(this, Fe).filter((t) => t !== e)), this.scheduleGc(), f(this, de).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    f(this, Fe).length || (this.state.status === "pending" ? this.scheduleGc() : f(this, de).remove(this));
  }
  continue() {
    var e;
    return ((e = f(this, rt)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var s, n, a, o, l, c, u, d, h, p, m, v, y, S, O, E, N, R, g, C;
    P(this, rt, un({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (w, x) => {
        $(this, Ie, Ue).call(this, { type: "failed", failureCount: w, error: x });
      },
      onPause: () => {
        $(this, Ie, Ue).call(this, { type: "pause" });
      },
      onContinue: () => {
        $(this, Ie, Ue).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => f(this, de).canRun(this)
    }));
    const t = this.state.status === "pending", r = !f(this, rt).canStart();
    try {
      if (!t) {
        $(this, Ie, Ue).call(this, { type: "pending", variables: e, isPaused: r }), await ((n = (s = f(this, de).config).onMutate) == null ? void 0 : n.call(
          s,
          e,
          this
        ));
        const x = await ((o = (a = this.options).onMutate) == null ? void 0 : o.call(a, e));
        x !== this.state.context && $(this, Ie, Ue).call(this, {
          type: "pending",
          context: x,
          variables: e,
          isPaused: r
        });
      }
      const w = await f(this, rt).start();
      return await ((c = (l = f(this, de).config).onSuccess) == null ? void 0 : c.call(
        l,
        w,
        e,
        this.state.context,
        this
      )), await ((d = (u = this.options).onSuccess) == null ? void 0 : d.call(u, w, e, this.state.context)), await ((p = (h = f(this, de).config).onSettled) == null ? void 0 : p.call(
        h,
        w,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((v = (m = this.options).onSettled) == null ? void 0 : v.call(m, w, null, e, this.state.context)), $(this, Ie, Ue).call(this, { type: "success", data: w }), w;
    } catch (w) {
      try {
        throw await ((S = (y = f(this, de).config).onError) == null ? void 0 : S.call(
          y,
          w,
          e,
          this.state.context,
          this
        )), await ((E = (O = this.options).onError) == null ? void 0 : E.call(
          O,
          w,
          e,
          this.state.context
        )), await ((R = (N = f(this, de).config).onSettled) == null ? void 0 : R.call(
          N,
          void 0,
          w,
          this.state.variables,
          this.state.context,
          this
        )), await ((C = (g = this.options).onSettled) == null ? void 0 : C.call(
          g,
          void 0,
          w,
          e,
          this.state.context
        )), w;
      } finally {
        $(this, Ie, Ue).call(this, { type: "error", error: w });
      }
    } finally {
      f(this, de).runNext(this);
    }
  }
}, Fe = new WeakMap(), de = new WeakMap(), rt = new WeakMap(), Ie = new WeakSet(), Ue = function(e) {
  const t = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: e.error,
          failureCount: r.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = t(this.state), le.batch(() => {
    f(this, Fe).forEach((r) => {
      r.onMutationUpdate(e);
    }), f(this, de).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, js);
function sl() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var ye, Jt, zs, nl = (zs = class extends ii {
  constructor(e = {}) {
    super();
    L(this, ye);
    L(this, Jt);
    this.config = e, P(this, ye, /* @__PURE__ */ new Map()), P(this, Jt, Date.now());
  }
  build(e, t, r) {
    const s = new rl({
      mutationCache: this,
      mutationId: ++ni(this, Jt)._,
      options: e.defaultMutationOptions(t),
      state: r
    });
    return this.add(s), s;
  }
  add(e) {
    const t = oi(e), r = f(this, ye).get(t) ?? [];
    r.push(e), f(this, ye).set(t, r), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    var r;
    const t = oi(e);
    if (f(this, ye).has(t)) {
      const s = (r = f(this, ye).get(t)) == null ? void 0 : r.filter((n) => n !== e);
      s && (s.length === 0 ? f(this, ye).delete(t) : f(this, ye).set(t, s));
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    var r;
    const t = (r = f(this, ye).get(oi(e))) == null ? void 0 : r.find((s) => s.state.status === "pending");
    return !t || t === e;
  }
  runNext(e) {
    var r;
    const t = (r = f(this, ye).get(oi(e))) == null ? void 0 : r.find((s) => s !== e && s.state.isPaused);
    return (t == null ? void 0 : t.continue()) ?? Promise.resolve();
  }
  clear() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return [...f(this, ye).values()].flat();
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => cs(t, r)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => cs(e, t));
  }
  notify(e) {
    le.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return le.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(Se))
      )
    );
  }
}, ye = new WeakMap(), Jt = new WeakMap(), zs);
function oi(i) {
  var e;
  return ((e = i.options.scope) == null ? void 0 : e.id) ?? String(i.mutationId);
}
function vi(i) {
  return {
    onFetch: (e, t) => {
      var u, d, h, p, m;
      const r = e.options, s = (h = (d = (u = e.fetchOptions) == null ? void 0 : u.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : h.direction, n = ((p = e.state.data) == null ? void 0 : p.pages) || [], a = ((m = e.state.data) == null ? void 0 : m.pageParams) || [];
      let o = { pages: [], pageParams: [] }, l = 0;
      const c = async () => {
        let v = !1;
        const y = (E) => {
          Object.defineProperty(E, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? v = !0 : e.signal.addEventListener("abort", () => {
              v = !0;
            }), e.signal)
          });
        }, S = on(e.options, e.fetchOptions), O = async (E, N, R) => {
          if (v)
            return Promise.reject();
          if (N == null && E.pages.length)
            return Promise.resolve(E);
          const g = {
            queryKey: e.queryKey,
            pageParam: N,
            direction: R ? "backward" : "forward",
            meta: e.options.meta
          };
          y(g);
          const C = await S(
            g
          ), { maxPages: w } = e.options, x = R ? Yo : qo;
          return {
            pages: x(E.pages, C, w),
            pageParams: x(E.pageParams, N, w)
          };
        };
        if (s && n.length) {
          const E = s === "backward", N = E ? fn : qi, R = {
            pages: n,
            pageParams: a
          }, g = N(r, R);
          o = await O(R, g, E);
        } else {
          const E = i ?? n.length;
          do {
            const N = l === 0 ? a[0] ?? r.initialPageParam : qi(r, o);
            if (l > 0 && N == null)
              break;
            o = await O(o, N), l++;
          } while (l < E);
        }
        return o;
      };
      e.options.persister ? e.fetchFn = () => {
        var v, y;
        return (y = (v = e.options).persister) == null ? void 0 : y.call(
          v,
          c,
          {
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          t
        );
      } : e.fetchFn = c;
    }
  };
}
function qi(i, { pages: e, pageParams: t }) {
  const r = e.length - 1;
  return e.length > 0 ? i.getNextPageParam(
    e[r],
    e,
    t[r],
    t
  ) : void 0;
}
function fn(i, { pages: e, pageParams: t }) {
  var r;
  return e.length > 0 ? (r = i.getPreviousPageParam) == null ? void 0 : r.call(i, e[0], e, t[0], t) : void 0;
}
function al(i, e) {
  return e ? qi(i, e) != null : !1;
}
function ol(i, e) {
  return !e || !i.getPreviousPageParam ? !1 : fn(i, e) != null;
}
var te, He, Ve, Nt, _t, We, Rt, Pt, Us, ll = (Us = class {
  constructor(i = {}) {
    L(this, te);
    L(this, He);
    L(this, Ve);
    L(this, Nt);
    L(this, _t);
    L(this, We);
    L(this, Rt);
    L(this, Pt);
    P(this, te, i.queryCache || new il()), P(this, He, i.mutationCache || new nl()), P(this, Ve, i.defaultOptions || {}), P(this, Nt, /* @__PURE__ */ new Map()), P(this, _t, /* @__PURE__ */ new Map()), P(this, We, 0);
  }
  mount() {
    ni(this, We)._++, f(this, We) === 1 && (P(this, Rt, br.subscribe(async (i) => {
      i && (await this.resumePausedMutations(), f(this, te).onFocus());
    })), P(this, Pt, gi.subscribe(async (i) => {
      i && (await this.resumePausedMutations(), f(this, te).onOnline());
    })));
  }
  unmount() {
    var i, e;
    ni(this, We)._--, f(this, We) === 0 && ((i = f(this, Rt)) == null || i.call(this), P(this, Rt, void 0), (e = f(this, Pt)) == null || e.call(this), P(this, Pt, void 0));
  }
  isFetching(i) {
    return f(this, te).findAll({ ...i, fetchStatus: "fetching" }).length;
  }
  isMutating(i) {
    return f(this, He).findAll({ ...i, status: "pending" }).length;
  }
  getQueryData(i) {
    var t;
    const e = this.defaultQueryOptions({ queryKey: i });
    return (t = f(this, te).get(e.queryHash)) == null ? void 0 : t.state.data;
  }
  ensureQueryData(i) {
    const e = this.getQueryData(i.queryKey);
    if (e === void 0)
      return this.fetchQuery(i);
    {
      const t = this.defaultQueryOptions(i), r = f(this, te).build(this, t);
      return i.revalidateIfStale && r.isStaleByTime(yt(t.staleTime, r)) && this.prefetchQuery(t), Promise.resolve(e);
    }
  }
  getQueriesData(i) {
    return f(this, te).findAll(i).map(({ queryKey: e, state: t }) => {
      const r = t.data;
      return [e, r];
    });
  }
  setQueryData(i, e, t) {
    const r = this.defaultQueryOptions({ queryKey: i }), s = f(this, te).get(
      r.queryHash
    ), n = s == null ? void 0 : s.state.data, a = Ko(e, n);
    if (a !== void 0)
      return f(this, te).build(this, r).setData(a, { ...t, manual: !0 });
  }
  setQueriesData(i, e, t) {
    return le.batch(
      () => f(this, te).findAll(i).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, e, t)
      ])
    );
  }
  getQueryState(i) {
    var t;
    const e = this.defaultQueryOptions({ queryKey: i });
    return (t = f(this, te).get(e.queryHash)) == null ? void 0 : t.state;
  }
  removeQueries(i) {
    const e = f(this, te);
    le.batch(() => {
      e.findAll(i).forEach((t) => {
        e.remove(t);
      });
    });
  }
  resetQueries(i, e) {
    const t = f(this, te), r = {
      type: "active",
      ...i
    };
    return le.batch(() => (t.findAll(i).forEach((s) => {
      s.reset();
    }), this.refetchQueries(r, e)));
  }
  cancelQueries(i = {}, e = {}) {
    const t = { revert: !0, ...e }, r = le.batch(
      () => f(this, te).findAll(i).map((s) => s.cancel(t))
    );
    return Promise.all(r).then(Se).catch(Se);
  }
  invalidateQueries(i = {}, e = {}) {
    return le.batch(() => {
      if (f(this, te).findAll(i).forEach((r) => {
        r.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const t = {
        ...i,
        type: i.refetchType ?? i.type ?? "active"
      };
      return this.refetchQueries(t, e);
    });
  }
  refetchQueries(i = {}, e) {
    const t = {
      ...e,
      cancelRefetch: (e == null ? void 0 : e.cancelRefetch) ?? !0
    }, r = le.batch(
      () => f(this, te).findAll(i).filter((s) => !s.isDisabled()).map((s) => {
        let n = s.fetch(void 0, t);
        return t.throwOnError || (n = n.catch(Se)), s.state.fetchStatus === "paused" ? Promise.resolve() : n;
      })
    );
    return Promise.all(r).then(Se);
  }
  fetchQuery(i) {
    const e = this.defaultQueryOptions(i);
    e.retry === void 0 && (e.retry = !1);
    const t = f(this, te).build(this, e);
    return t.isStaleByTime(
      yt(e.staleTime, t)
    ) ? t.fetch(e) : Promise.resolve(t.state.data);
  }
  prefetchQuery(i) {
    return this.fetchQuery(i).then(Se).catch(Se);
  }
  fetchInfiniteQuery(i) {
    return i.behavior = vi(i.pages), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(i) {
    return this.fetchInfiniteQuery(i).then(Se).catch(Se);
  }
  ensureInfiniteQueryData(i) {
    return i.behavior = vi(i.pages), this.ensureQueryData(i);
  }
  resumePausedMutations() {
    return gi.isOnline() ? f(this, He).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return f(this, te);
  }
  getMutationCache() {
    return f(this, He);
  }
  getDefaultOptions() {
    return f(this, Ve);
  }
  setDefaultOptions(i) {
    P(this, Ve, i);
  }
  setQueryDefaults(i, e) {
    f(this, Nt).set(Qt(i), {
      queryKey: i,
      defaultOptions: e
    });
  }
  getQueryDefaults(i) {
    const e = [...f(this, Nt).values()];
    let t = {};
    return e.forEach((r) => {
      qt(i, r.queryKey) && (t = { ...t, ...r.defaultOptions });
    }), t;
  }
  setMutationDefaults(i, e) {
    f(this, _t).set(Qt(i), {
      mutationKey: i,
      defaultOptions: e
    });
  }
  getMutationDefaults(i) {
    const e = [...f(this, _t).values()];
    let t = {};
    return e.forEach((r) => {
      qt(i, r.mutationKey) && (t = { ...t, ...r.defaultOptions });
    }), t;
  }
  defaultQueryOptions(i) {
    if (i._defaulted)
      return i;
    const e = {
      ...f(this, Ve).queries,
      ...this.getQueryDefaults(i.queryKey),
      ...i,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = yr(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.enabled !== !0 && e.queryFn === mi && (e.enabled = !1), e;
  }
  defaultMutationOptions(i) {
    return i != null && i._defaulted ? i : {
      ...f(this, Ve).mutations,
      ...(i == null ? void 0 : i.mutationKey) && this.getMutationDefaults(i.mutationKey),
      ...i,
      _defaulted: !0
    };
  }
  clear() {
    f(this, te).clear(), f(this, He).clear();
  }
}, te = new WeakMap(), He = new WeakMap(), Ve = new WeakMap(), Nt = new WeakMap(), _t = new WeakMap(), We = new WeakMap(), Rt = new WeakMap(), Pt = new WeakMap(), Us), me, B, Zt, fe, st, Dt, Ke, Le, ei, Ft, It, nt, at, Qe, Lt, K, Bt, Yi, Xi, Gi, Ji, Zi, er, tr, mn, $s, pn = ($s = class extends ii {
  constructor(e, t) {
    super();
    L(this, K);
    L(this, me);
    L(this, B);
    L(this, Zt);
    L(this, fe);
    L(this, st);
    L(this, Dt);
    L(this, Ke);
    L(this, Le);
    L(this, ei);
    L(this, Ft);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    L(this, It);
    L(this, nt);
    L(this, at);
    L(this, Qe);
    L(this, Lt, /* @__PURE__ */ new Set());
    this.options = t, P(this, me, e), P(this, Le, null), P(this, Ke, Qi()), this.options.experimental_prefetchInRender || f(this, Ke).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(t);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (f(this, B).addObserver(this), ds(f(this, B), this.options) ? $(this, K, Bt).call(this) : this.updateResult(), $(this, K, Ji).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return ir(
      f(this, B),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return ir(
      f(this, B),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), $(this, K, Zi).call(this), $(this, K, er).call(this), f(this, B).removeObserver(this);
  }
  setOptions(e, t) {
    const r = this.options, s = f(this, B);
    if (this.options = f(this, me).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Pe(this.options.enabled, f(this, B)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    $(this, K, tr).call(this), f(this, B).setOptions(this.options), r._defaulted && !Vi(this.options, r) && f(this, me).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: f(this, B),
      observer: this
    });
    const n = this.hasListeners();
    n && fs(
      f(this, B),
      s,
      this.options,
      r
    ) && $(this, K, Bt).call(this), this.updateResult(t), n && (f(this, B) !== s || Pe(this.options.enabled, f(this, B)) !== Pe(r.enabled, f(this, B)) || yt(this.options.staleTime, f(this, B)) !== yt(r.staleTime, f(this, B))) && $(this, K, Yi).call(this);
    const a = $(this, K, Xi).call(this);
    n && (f(this, B) !== s || Pe(this.options.enabled, f(this, B)) !== Pe(r.enabled, f(this, B)) || a !== f(this, Qe)) && $(this, K, Gi).call(this, a);
  }
  getOptimisticResult(e) {
    const t = f(this, me).getQueryCache().build(f(this, me), e), r = this.createResult(t, e);
    return ul(this, r) && (P(this, fe, r), P(this, Dt, this.options), P(this, st, f(this, B).state)), r;
  }
  getCurrentResult() {
    return f(this, fe);
  }
  trackResult(e, t) {
    const r = {};
    return Object.keys(e).forEach((s) => {
      Object.defineProperty(r, s, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(s), t == null || t(s), e[s])
      });
    }), r;
  }
  trackProp(e) {
    f(this, Lt).add(e);
  }
  getCurrentQuery() {
    return f(this, B);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const t = f(this, me).defaultQueryOptions(e), r = f(this, me).getQueryCache().build(f(this, me), t);
    return r.fetch().then(() => this.createResult(r, t));
  }
  fetch(e) {
    return $(this, K, Bt).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), f(this, fe)));
  }
  createResult(e, t) {
    var w;
    const r = f(this, B), s = this.options, n = f(this, fe), a = f(this, st), o = f(this, Dt), c = e !== r ? e.state : f(this, Zt), { state: u } = e;
    let d = { ...u }, h = !1, p;
    if (t._optimisticResults) {
      const x = this.hasListeners(), _ = !x && ds(e, t), F = x && fs(e, r, t, s);
      (_ || F) && (d = {
        ...d,
        ...dn(u.data, e.options)
      }), t._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: m, errorUpdatedAt: v, status: y } = d;
    if (t.select && d.data !== void 0)
      if (n && d.data === (a == null ? void 0 : a.data) && t.select === f(this, ei))
        p = f(this, Ft);
      else
        try {
          P(this, ei, t.select), p = t.select(d.data), p = Ki(n == null ? void 0 : n.data, p, t), P(this, Ft, p), P(this, Le, null);
        } catch (x) {
          P(this, Le, x);
        }
    else
      p = d.data;
    if (t.placeholderData !== void 0 && p === void 0 && y === "pending") {
      let x;
      if (n != null && n.isPlaceholderData && t.placeholderData === (o == null ? void 0 : o.placeholderData))
        x = n.data;
      else if (x = typeof t.placeholderData == "function" ? t.placeholderData(
        (w = f(this, It)) == null ? void 0 : w.state.data,
        f(this, It)
      ) : t.placeholderData, t.select && x !== void 0)
        try {
          x = t.select(x), P(this, Le, null);
        } catch (_) {
          P(this, Le, _);
        }
      x !== void 0 && (y = "success", p = Ki(
        n == null ? void 0 : n.data,
        x,
        t
      ), h = !0);
    }
    f(this, Le) && (m = f(this, Le), p = f(this, Ft), v = Date.now(), y = "error");
    const S = d.fetchStatus === "fetching", O = y === "pending", E = y === "error", N = O && S, R = p !== void 0, C = {
      status: y,
      fetchStatus: d.fetchStatus,
      isPending: O,
      isSuccess: y === "success",
      isError: E,
      isInitialLoading: N,
      isLoading: N,
      data: p,
      dataUpdatedAt: d.dataUpdatedAt,
      error: m,
      errorUpdatedAt: v,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > c.dataUpdateCount || d.errorUpdateCount > c.errorUpdateCount,
      isFetching: S,
      isRefetching: S && !O,
      isLoadingError: E && !R,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: h,
      isRefetchError: E && R,
      isStale: wr(e, t),
      refetch: this.refetch,
      promise: f(this, Ke)
    };
    if (this.options.experimental_prefetchInRender) {
      const x = (I) => {
        C.status === "error" ? I.reject(C.error) : C.data !== void 0 && I.resolve(C.data);
      }, _ = () => {
        const I = P(this, Ke, C.promise = Qi());
        x(I);
      }, F = f(this, Ke);
      switch (F.status) {
        case "pending":
          e.queryHash === r.queryHash && x(F);
          break;
        case "fulfilled":
          (C.status === "error" || C.data !== F.value) && _();
          break;
        case "rejected":
          (C.status !== "error" || C.error !== F.reason) && _();
          break;
      }
    }
    return C;
  }
  updateResult(e) {
    const t = f(this, fe), r = this.createResult(f(this, B), this.options);
    if (P(this, st, f(this, B).state), P(this, Dt, this.options), f(this, st).data !== void 0 && P(this, It, f(this, B)), Vi(r, t))
      return;
    P(this, fe, r);
    const s = {}, n = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: a } = this.options, o = typeof a == "function" ? a() : a;
      if (o === "all" || !o && !f(this, Lt).size)
        return !0;
      const l = new Set(
        o ?? f(this, Lt)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(f(this, fe)).some((c) => {
        const u = c;
        return f(this, fe)[u] !== t[u] && l.has(u);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && n() && (s.listeners = !0), $(this, K, mn).call(this, { ...s, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && $(this, K, Ji).call(this);
  }
}, me = new WeakMap(), B = new WeakMap(), Zt = new WeakMap(), fe = new WeakMap(), st = new WeakMap(), Dt = new WeakMap(), Ke = new WeakMap(), Le = new WeakMap(), ei = new WeakMap(), Ft = new WeakMap(), It = new WeakMap(), nt = new WeakMap(), at = new WeakMap(), Qe = new WeakMap(), Lt = new WeakMap(), K = new WeakSet(), Bt = function(e) {
  $(this, K, tr).call(this);
  let t = f(this, B).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (t = t.catch(Se)), t;
}, Yi = function() {
  $(this, K, Zi).call(this);
  const e = yt(
    this.options.staleTime,
    f(this, B)
  );
  if (lt || f(this, fe).isStale || !Bi(e))
    return;
  const r = an(f(this, fe).dataUpdatedAt, e) + 1;
  P(this, nt, setTimeout(() => {
    f(this, fe).isStale || this.updateResult();
  }, r));
}, Xi = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(f(this, B)) : this.options.refetchInterval) ?? !1;
}, Gi = function(e) {
  $(this, K, er).call(this), P(this, Qe, e), !(lt || Pe(this.options.enabled, f(this, B)) === !1 || !Bi(f(this, Qe)) || f(this, Qe) === 0) && P(this, at, setInterval(() => {
    (this.options.refetchIntervalInBackground || br.isFocused()) && $(this, K, Bt).call(this);
  }, f(this, Qe)));
}, Ji = function() {
  $(this, K, Yi).call(this), $(this, K, Gi).call(this, $(this, K, Xi).call(this));
}, Zi = function() {
  f(this, nt) && (clearTimeout(f(this, nt)), P(this, nt, void 0));
}, er = function() {
  f(this, at) && (clearInterval(f(this, at)), P(this, at, void 0));
}, tr = function() {
  const e = f(this, me).getQueryCache().build(f(this, me), this.options);
  if (e === f(this, B))
    return;
  const t = f(this, B);
  P(this, B, e), P(this, Zt, e.state), this.hasListeners() && (t == null || t.removeObserver(this), e.addObserver(this));
}, mn = function(e) {
  le.batch(() => {
    e.listeners && this.listeners.forEach((t) => {
      t(f(this, fe));
    }), f(this, me).getQueryCache().notify({
      query: f(this, B),
      type: "observerResultsUpdated"
    });
  });
}, $s);
function cl(i, e) {
  return Pe(e.enabled, i) !== !1 && i.state.data === void 0 && !(i.state.status === "error" && e.retryOnMount === !1);
}
function ds(i, e) {
  return cl(i, e) || i.state.data !== void 0 && ir(i, e, e.refetchOnMount);
}
function ir(i, e, t) {
  if (Pe(e.enabled, i) !== !1) {
    const r = typeof t == "function" ? t(i) : t;
    return r === "always" || r !== !1 && wr(i, e);
  }
  return !1;
}
function fs(i, e, t, r) {
  return (i !== e || Pe(r.enabled, i) === !1) && (!t.suspense || i.state.status !== "error") && wr(i, t);
}
function wr(i, e) {
  return Pe(e.enabled, i) !== !1 && i.isStaleByTime(yt(e.staleTime, i));
}
function ul(i, e) {
  return !Vi(i.getCurrentResult(), e);
}
var hl = class extends pn {
  constructor(i, e) {
    super(i, e);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(i, e) {
    super.setOptions(
      {
        ...i,
        behavior: vi()
      },
      e
    );
  }
  getOptimisticResult(i) {
    return i.behavior = vi(), super.getOptimisticResult(i);
  }
  fetchNextPage(i) {
    return this.fetch({
      ...i,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(i) {
    return this.fetch({
      ...i,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(i, e) {
    var m, v;
    const { state: t } = i, r = super.createResult(i, e), { isFetching: s, isRefetching: n, isError: a, isRefetchError: o } = r, l = (v = (m = t.fetchMeta) == null ? void 0 : m.fetchMore) == null ? void 0 : v.direction, c = a && l === "forward", u = s && l === "forward", d = a && l === "backward", h = s && l === "backward";
    return {
      ...r,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: al(e, t.data),
      hasPreviousPage: ol(e, t.data),
      isFetchNextPageError: c,
      isFetchingNextPage: u,
      isFetchPreviousPageError: d,
      isFetchingPreviousPage: h,
      isRefetchError: o && !c && !d,
      isRefetching: n && !u && !h
    };
  }
}, gn = ce.createContext(
  void 0
), Si = (i) => {
  const e = ce.useContext(gn);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, dl = ({
  client: i,
  children: e
}) => (ce.useEffect(() => (i.mount(), () => {
  i.unmount();
}), [i]), /* @__PURE__ */ b(gn.Provider, { value: i, children: e })), vn = ce.createContext(!1), fl = () => ce.useContext(vn);
vn.Provider;
function pl() {
  let i = !1;
  return {
    clearReset: () => {
      i = !1;
    },
    reset: () => {
      i = !0;
    },
    isReset: () => i
  };
}
var ml = ce.createContext(pl()), gl = () => ce.useContext(ml);
function vl(i, e) {
  return typeof i == "function" ? i(...e) : !!i;
}
function yl() {
}
var bl = (i, e) => {
  (i.suspense || i.throwOnError || i.experimental_prefetchInRender) && (e.isReset() || (i.retryOnMount = !1));
}, wl = (i) => {
  ce.useEffect(() => {
    i.clearReset();
  }, [i]);
}, xl = ({
  result: i,
  errorResetBoundary: e,
  throwOnError: t,
  query: r
}) => i.isError && !e.isReset() && !i.isFetching && r && vl(t, [i.error, r]), Cl = (i) => {
  i.suspense && (i.staleTime === void 0 && (i.staleTime = 1e3), typeof i.gcTime == "number" && (i.gcTime = Math.max(i.gcTime, 1e3)));
}, Sl = (i, e) => i.isLoading && i.isFetching && !e, Ol = (i, e) => (i == null ? void 0 : i.suspense) && e.isPending, ps = (i, e, t) => e.fetchOptimistic(i).catch(() => {
  t.clearReset();
});
function yn(i, e, t) {
  var u, d, h, p, m;
  if (process.env.NODE_ENV !== "production" && (typeof i != "object" || Array.isArray(i)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Si(), s = fl(), n = gl(), a = r.defaultQueryOptions(i);
  (d = (u = r.getDefaultOptions().queries) == null ? void 0 : u._experimental_beforeQuery) == null || d.call(
    u,
    a
  ), a._optimisticResults = s ? "isRestoring" : "optimistic", Cl(a), bl(a, n), wl(n);
  const o = !r.getQueryCache().get(a.queryHash), [l] = ce.useState(
    () => new e(
      r,
      a
    )
  ), c = l.getOptimisticResult(a);
  if (ce.useSyncExternalStore(
    ce.useCallback(
      (v) => {
        const y = s ? () => {
        } : l.subscribe(le.batchCalls(v));
        return l.updateResult(), y;
      },
      [l, s]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), ce.useEffect(() => {
    l.setOptions(a, { listeners: !1 });
  }, [a, l]), Ol(a, c))
    throw ps(a, l, n);
  if (xl({
    result: c,
    errorResetBoundary: n,
    throwOnError: a.throwOnError,
    query: r.getQueryCache().get(a.queryHash)
  }))
    throw c.error;
  if ((p = (h = r.getDefaultOptions().queries) == null ? void 0 : h._experimental_afterQuery) == null || p.call(
    h,
    a,
    c
  ), a.experimental_prefetchInRender && !lt && Sl(c, s)) {
    const v = o ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      ps(a, l, n)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (m = r.getQueryCache().get(a.queryHash)) == null ? void 0 : m.promise
    );
    v == null || v.catch(yl).finally(() => {
      l.updateResult();
    });
  }
  return a.notifyOnChangeProps ? c : l.trackResult(c);
}
function bn(i, e) {
  return yn(i, pn);
}
function El(i, e) {
  return yn(
    i,
    hl
  );
}
const Nl = new ll({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function vu({ children: i }) {
  return /* @__PURE__ */ b(dl, { client: Nl, children: i });
}
const _l = Hs(null), yu = ({
  children: i,
  languageCode: e
}) => {
  const [t, r] = V(e), s = ca((n) => {
    re.hasResourceBundle(n, gr) ? (re.changeLanguage(n), r(n)) : Lo(n).then(() => {
      re.changeLanguage(n), r(n);
    });
  }, []);
  return Ee(() => {
    re.isInitialized && s(e);
  }, [e, s]), /* @__PURE__ */ b(_l.Provider, { value: { currentLanguageCode: t, changeLocale: s }, children: i });
}, Rl = "/api/dashboard/customer", xr = "/api/dashboard/customer/data-files", Pl = `${xr}/validate-and-get-upload-options`, Dl = (i) => `${xr}/${i}/activate-file`, Fl = (i) => `${Rl}/draft-file/${i}`, wn = "/api/data-files", Il = `${wn}/validate-and-get-upload-options`, Ll = (i) => `${wn}/${i}/activate-file`, Oi = "/api/dashboard/management/data-files", kl = `${Oi}/validate-and-get-upload-options`, Ml = (i) => `${Oi}/${i}/activate-file`, Tl = (i) => `${Oi}/${i}/delete-draft`, xn = async ({
  startFrom: i,
  limit: e,
  order: t,
  sortColumn: r,
  sortDirection: s,
  filter: n,
  fileManagerApiType: a
}) => {
  var c, u;
  const o = () => a != null && a.isCommon ? Oi : xr;
  return (await vr.get(
    o() + "?" + (n != null && n.name ? `&filter[names][]=${n == null ? void 0 : n.name}` : "") + ((c = n == null ? void 0 : n.source) != null && c.length ? n.source.map((d) => `&filter[sources][]=${encodeURIComponent(d)}`).join("") : "") + ((u = n == null ? void 0 : n.type) != null && u.length ? n.type.map((d) => `&filter[types][]=${encodeURIComponent(d)}`).join("") : "") + (i ? `&pagination[startFrom]=${i}` : "") + (r ? `&pagination[sortColumn]=${r}` : "") + (s ? `&pagination[sortDirection]=${s}` : "") + (e ? `&pagination[limit]=${e}` : "") + (t ? `&pagination[order]=${t}` : "")
  )).data;
}, bu = ({
  startFrom: i,
  limit: e = 10,
  order: t = mr.Next,
  sortColumn: r,
  sortDirection: s,
  filter: n,
  fileManagerApiType: a
}, o) => {
  const l = Si(), u = a != null && a.isCommon ? "common-data-files" : a != null && a.isPublic ? "public-data-files" : "data-files", d = [u], h = [
    u,
    { startFrom: i, limit: e, order: t, sortColumn: r, sortDirection: s, filter: n }
  ];
  return {
    ...bn({
      queryKey: h,
      queryFn: () => xn({ startFrom: i, limit: e, order: t, sortColumn: r, sortDirection: s, filter: n, fileManagerApiType: a }),
      ...o
    }),
    resetAndRefetch: () => {
      l.invalidateQueries({ queryKey: d });
    },
    triggerFetch: () => {
      l.fetchQuery({ queryKey: h });
    },
    deleteItemFromData: (O) => {
      l.getQueryCache().findAll({ queryKey: d }).forEach((N) => {
        l.setQueryData(
          N.queryKey,
          (R) => {
            if (R)
              return {
                ...R,
                items: R.items.filter((g) => g.id !== O)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: O, name: E }) => {
      l.getQueryCache().findAll({ queryKey: d }).forEach((R) => {
        l.setQueryData(
          R.queryKey,
          (g) => {
            if (g)
              return {
                ...g,
                items: g.items.map((C) => C.id === O ? { ...C, name: E } : C)
              };
          }
        );
      });
    }
  };
}, Al = ({
  limit: i = 10,
  order: e = mr.Next,
  sortColumn: t,
  sortDirection: r,
  filter: s,
  fileManagerApiType: n
}, a) => {
  const o = Si(), u = [n != null && n.isCommon ? "common-infinite-data-files" : n != null && n.isPublic ? "public-infinite-data-files" : "infinite-data-files", { limit: i, order: e, sortColumn: t, sortDirection: r, filter: s }];
  return { ...El({
    initialPageParam: void 0,
    queryKey: u,
    queryFn: ({ pageParam: v }) => xn({
      startFrom: typeof v == "string" ? v : void 0,
      limit: i,
      order: e,
      sortColumn: t,
      sortDirection: r,
      filter: s,
      fileManagerApiType: n
    }),
    getPreviousPageParam: (v) => {
      if (!v.hasMore) return;
      const y = v.items[0];
      if (y)
        return encodeURIComponent(
          JSON.stringify({
            id: y.id,
            field: y[t ?? "name"]
          })
        );
    },
    getNextPageParam: (v) => {
      if (!v.hasMore) return;
      const y = v.items[v.items.length - 1];
      if (y)
        return encodeURIComponent(
          JSON.stringify({
            id: y.id,
            field: y[t ?? "name"]
          })
        );
    },
    ...a
  }), resetAndRefetch: () => {
    o.invalidateQueries({ queryKey: u });
  }, deleteItemFromData: (v) => {
    o.setQueryData(u, (y) => y && {
      ...y,
      pages: y.pages.map((S) => ({
        ...S,
        items: S.items.filter((O) => O.id !== v)
      }))
    });
  }, renameItemFromData: ({ id: v, name: y }) => {
    o.setQueryData(u, (S) => S && {
      ...S,
      pages: S.pages.map((O) => ({
        ...O,
        items: O.items.map((E) => E.id === v ? { ...E, name: y } : E)
      }))
    });
  } };
}, jl = ({ id: i, fileManagerApiType: e }, t) => {
  const r = Si(), s = ["file-details", { id: i }], n = () => e != null && e.isCommon ? "/api/dashboard/management/data-files/" : "/api/dashboard/customer/data-files/";
  return { ...bn({
    queryKey: s,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof i < "u",
    queryFn: async ({ queryKey: l }) => {
      const [, { id: c }] = l;
      return (await vr.get(n() + c)).data;
    },
    ...t
  }), resetAndRefetch: () => {
    r.invalidateQueries({ queryKey: s });
  } };
}, Cn = () => {
  const { fetcher: i } = vt({
    method: gt.delete
  }), { fetcher: e } = vt({
    method: gt.get
  }), { fetcher: t } = vt({
    method: gt.post
  });
  return { deleteFile: async ({ id: a }) => {
    await i("/api/dashboard/customer/data-files/" + a);
  }, downloadFile: async ({ id: a }) => {
    const { link: o } = await e(`/api/dashboard/customer/data-files/${a}/download-link`), l = document.createElement("a");
    l.setAttribute("href", o), l.setAttribute("download", ""), l.click();
  }, renameFile: async ({ id: a, name: o }) => await t(`/api/dashboard/customer/data-files/${a}/rename`, {
    name: o
  }) };
};
function zl({
  isFetching: i,
  values: e,
  disabled: t,
  disabledFileSourceSelect: r,
  disabledFileTypeSelect: s,
  onChange: n,
  onSubmit: a
}) {
  const { t: o } = pe();
  return /* @__PURE__ */ j(
    "form",
    {
      onSubmit: (l) => {
        l.preventDefault(), l.stopPropagation(), a();
      },
      className: "flex flex-col gap-2 sm:grid sm:grid-cols-2 lg:flex lg:flex-row lg:items-end lg:flex-wrap",
      children: [
        /* @__PURE__ */ b(
          ia,
          {
            disabled: i || t,
            label: o("file_manager.file_selector.search_file"),
            placeholder: o("file_manager.search"),
            value: e.name,
            onClear: () => n == null ? void 0 : n({ ...e, name: "" }),
            onChange: (l) => n == null ? void 0 : n({ ...e, name: l.target.value }),
            showSearchIcon: !0,
            className: "lg:flex-2",
            labelClassName: "text-text-primary text-lg font-bold",
            searchIconClassName: "left-3 top-[31px]",
            closeIconClassName: "top-[31px]",
            inputClassName: "!pl-[40px] pr-4"
          }
        ),
        /* @__PURE__ */ b(
          Mr,
          {
            disabled: i || t || r,
            placeholder: o("file_manager.select_source"),
            value: e.source,
            data: Object.values(G).filter((l) => l !== G.BlockPreview && l !== G.Community).map((l) => ({
              id: l,
              caption: o(Ea[l])
            })),
            onChange: (l) => n == null ? void 0 : n({ ...e, source: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ b(
          Mr,
          {
            disabled: i || t || s,
            placeholder: o("file_manager.select_type"),
            value: e.type,
            data: Object.values(X).map((l) => ({
              id: l,
              caption: o(Na[l])
            })),
            onChange: (l) => n == null ? void 0 : n({ ...e, type: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ b(
          ti,
          {
            type: "submit",
            isFetching: i,
            disabled: t,
            className: "min-w-14",
            children: o("file_manager.search")
          }
        )
      ]
    }
  );
}
function dt(i, e, t) {
  let r = t.initialDeps ?? [], s;
  return () => {
    var n, a, o, l;
    let c;
    t.key && ((n = t.debug) != null && n.call(t)) && (c = Date.now());
    const u = i();
    if (!(u.length !== r.length || u.some((p, m) => r[m] !== p)))
      return s;
    r = u;
    let h;
    if (t.key && ((a = t.debug) != null && a.call(t)) && (h = Date.now()), s = e(...u), t.key && ((o = t.debug) != null && o.call(t))) {
      const p = Math.round((Date.now() - c) * 100) / 100, m = Math.round((Date.now() - h) * 100) / 100, v = m / 16, y = (S, O) => {
        for (S = String(S); S.length < O; )
          S = " " + S;
        return S;
      };
      console.info(
        `%c⏱ ${y(m, 5)} /${y(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * v, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return (l = t == null ? void 0 : t.onChange) == null || l.call(t, s), s;
  };
}
function Fi(i, e) {
  if (i === void 0)
    throw new Error("Unexpected undefined");
  return i;
}
const Ul = (i, e) => Math.abs(i - e) < 1, $l = (i, e, t) => {
  let r;
  return function(...s) {
    i.clearTimeout(r), r = i.setTimeout(() => e.apply(this, s), t);
  };
}, Bl = (i) => i, Hl = (i) => {
  const e = Math.max(i.startIndex - i.overscan, 0), t = Math.min(i.endIndex + i.overscan, i.count - 1), r = [];
  for (let s = e; s <= t; s++)
    r.push(s);
  return r;
}, Vl = (i, e) => {
  const t = i.scrollElement;
  if (!t)
    return;
  const r = i.targetWindow;
  if (!r)
    return;
  const s = (a) => {
    const { width: o, height: l } = a;
    e({ width: Math.round(o), height: Math.round(l) });
  };
  if (s(t.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const n = new r.ResizeObserver((a) => {
    const o = a[0];
    if (o != null && o.borderBoxSize) {
      const l = o.borderBoxSize[0];
      if (l) {
        s({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    s(t.getBoundingClientRect());
  });
  return n.observe(t, { box: "border-box" }), () => {
    n.unobserve(t);
  };
}, ms = {
  passive: !0
}, Wl = typeof window > "u" ? !0 : "onscrollend" in window, Kl = (i, e) => {
  const t = i.scrollElement;
  if (!t)
    return;
  const r = i.targetWindow;
  if (!r)
    return;
  let s = 0;
  const n = Wl ? () => {
  } : $l(
    r,
    () => {
      e(s, !1);
    },
    i.options.isScrollingResetDelay
  ), a = (c) => () => {
    const { horizontal: u, isRtl: d } = i.options;
    s = u ? t.scrollLeft * (d && -1 || 1) : t.scrollTop, n(), e(s, c);
  }, o = a(!0), l = a(!1);
  return l(), t.addEventListener("scroll", o, ms), t.addEventListener("scrollend", l, ms), () => {
    t.removeEventListener("scroll", o), t.removeEventListener("scrollend", l);
  };
}, Ql = (i, e, t) => {
  if (e != null && e.borderBoxSize) {
    const r = e.borderBoxSize[0];
    if (r)
      return Math.round(
        r[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    i.getBoundingClientRect()[t.options.horizontal ? "width" : "height"]
  );
}, ql = (i, {
  adjustments: e = 0,
  behavior: t
}, r) => {
  var s, n;
  const a = i + e;
  (n = (s = r.scrollElement) == null ? void 0 : s.scrollTo) == null || n.call(s, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: t
  });
};
class Yl {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const r = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((n) => {
          this._measureElement(n.target, n);
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = r()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var n;
          return (n = r()) == null ? void 0 : n.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var n;
          return (n = r()) == null ? void 0 : n.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([r, s]) => {
        typeof s > "u" && delete t[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Bl,
        rangeExtractor: Hl,
        onChange: () => {
        },
        measureElement: Ql,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...t
      };
    }, this.notify = (t) => {
      var r, s;
      (s = (r = this.options).onChange) == null || s.call(r, this, t);
    }, this.maybeNotify = dt(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, n) => {
            this.scrollAdjustments = 0, this.scrollDirection = n ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = n, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, r) => {
      const s = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const o = t[a];
        if (s.has(o.lane))
          continue;
        const l = n.get(
          o.lane
        );
        if (l == null || o.end > l.end ? n.set(o.lane, o) : o.end < l.end && s.set(o.lane, !0), s.size === this.options.lanes)
          break;
      }
      return n.size === this.options.lanes ? Array.from(n.values()).sort((a, o) => a.end === o.end ? a.index - o.index : a.end - o.end)[0] : void 0;
    }, this.getMeasurementOptions = dt(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (t, r, s, n, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: r,
        scrollMargin: s,
        getItemKey: n,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = dt(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: r, scrollMargin: s, getItemKey: n, enabled: a }, o) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < t; u++) {
          const d = n(u), h = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), p = h ? h.end + this.options.gap : r + s, m = o.get(d), v = typeof m == "number" ? m : this.options.estimateSize(u), y = p + v, S = h ? h.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: p,
            size: v,
            end: y,
            key: d,
            lane: S
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = dt(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (t, r, s) => this.range = t.length > 0 && r > 0 ? Xl({
        measurements: t,
        outerSize: r,
        scrollOffset: s
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = dt(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (t, r, s, n) => r === null ? [] : t({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: s,
        count: n
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const r = this.options.indexAttribute, s = t.getAttribute(r);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, r) => {
      const s = this.indexFromElement(t), n = this.measurementsCache[s];
      if (!n)
        return;
      const a = n.key, o = this.elementsCache.get(a);
      o !== t && (o && this.observer.unobserve(o), this.observer.observe(t), this.elementsCache.set(a, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, r, this));
    }, this.resizeItem = (t, r) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const n = this.itemSizeCache.get(s.key) ?? s.size, a = r - n;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, a, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, r)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((r, s) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = dt(
      () => [this.getIndexes(), this.getMeasurements()],
      (t, r) => {
        const s = [];
        for (let n = 0, a = t.length; n < a; n++) {
          const o = t[n], l = r[o];
          s.push(l);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Fi(
          r[Sn(
            0,
            r.length - 1,
            (s) => Fi(r[s]).start,
            t
          )]
        );
    }, this.getOffsetForAlignment = (t, r) => {
      const s = this.getSize(), n = this.getScrollOffset();
      r === "auto" && (t <= n ? r = "start" : t >= n + s ? r = "end" : r = "start"), r === "start" ? t = t : r === "end" ? t = t - s : r === "center" && (t = t - s / 2);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - s;
      return Math.max(Math.min(l, t), 0);
    }, this.getOffsetForIndex = (t, r = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const n = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (s.end >= a + n - this.options.scrollPaddingEnd)
          r = "end";
        else if (s.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const o = r === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(o, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (t, { align: r = "start", behavior: s } = {}) => {
      this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, r), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: r = "auto", behavior: s } = {}) => {
      t = Math.max(0, Math.min(t, this.options.count - 1)), this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const n = this.getOffsetForIndex(t, r);
      if (!n) return;
      const [a, o] = n;
      this._scrollToOffset(a, { adjustments: void 0, behavior: s }), s !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(t)
        )) {
          const [c] = Fi(
            this.getOffsetForIndex(t, o)
          );
          Ul(c, this.getScrollOffset()) || this.scrollToIndex(t, { align: o, behavior: s });
        } else
          this.scrollToIndex(t, { align: o, behavior: s });
      }));
    }, this.scrollBy = (t, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var t;
      const r = this.getMeasurements();
      let s;
      return r.length === 0 ? s = this.options.paddingStart : s = this.options.lanes === 1 ? ((t = r[r.length - 1]) == null ? void 0 : t.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((n) => n.end)
      ), Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: r,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const Sn = (i, e, t, r) => {
  for (; i <= e; ) {
    const s = (i + e) / 2 | 0, n = t(s);
    if (n < r)
      i = s + 1;
    else if (n > r)
      e = s - 1;
    else
      return s;
  }
  return i > 0 ? i - 1 : 0;
};
function Xl({
  measurements: i,
  outerSize: e,
  scrollOffset: t
}) {
  const r = i.length - 1, n = Sn(0, r, (o) => i[o].start, t);
  let a = n;
  for (; a < r && i[a].end < t + e; )
    a++;
  return { startIndex: n, endIndex: a };
}
const Gl = typeof document < "u" ? ce.useLayoutEffect : ce.useEffect;
function Jl(i) {
  const e = ce.useReducer(() => ({}), {})[1], t = {
    ...i,
    onChange: (s, n) => {
      var a;
      n ? Sa(e) : e(), (a = i.onChange) == null || a.call(i, s, n);
    }
  }, [r] = ce.useState(
    () => new Yl(t)
  );
  return r.setOptions(t), ce.useEffect(() => r._didMount(), []), Gl(() => r._willUpdate()), r;
}
function gs(i) {
  return Jl({
    observeElementRect: Vl,
    observeElementOffset: Kl,
    scrollToFn: ql,
    ...i
  });
}
const rr = 2, Zl = 6, ec = rr * 2 + Zl;
function tc({
  initialItemWidth: i = 150,
  initialItemHeight: e = 180,
  rowGap: t = 18,
  columnGap: r = 16,
  columnCount: s = 6,
  dataFilesApi: n,
  specialElementInGrid: a,
  onSelect: o,
  onDetails: l,
  onDelete: c,
  onRename: u,
  onDownload: d
}) {
  var ae;
  const h = Oe.useRef(null), p = Oe.useRef(null), [m, v] = V(s), [y, S] = V(i), [O, E] = V(e), [N, R] = V(), { data: g, fetchNextPage: C, hasNextPage: w, isFetchingNextPage: x, isFetching: _ } = n, F = "specialElementInGridId", I = a ? m >= 2 ? [F, F] : [F] : [], H = [...I, ...((ae = g == null ? void 0 : g.pages) == null ? void 0 : ae.flatMap((T) => T.items)) ?? []], U = H.length;
  Ee(() => {
    const T = () => {
      if (h.current) {
        const ee = h.current.offsetWidth - ec, W = Math.floor(ee / (i + r));
        v(W || 1);
        const D = (ee - r * (W - 1)) / W;
        S(D), E(D / i * e);
      }
    };
    T();
    const q = new ResizeObserver(T);
    return h.current && q.observe(h.current), () => q.disconnect();
  }, [i, e, r]);
  const Q = gs({
    count: Math.ceil(U / m),
    gap: t,
    getScrollElement: () => h.current,
    estimateSize: () => O
  }), M = gs({
    count: m,
    gap: r,
    getScrollElement: () => h.current,
    estimateSize: () => y,
    horizontal: !0
  });
  return Ee(() => {
    if (!p.current || !w || x) return;
    const T = new IntersectionObserver(
      (q) => {
        q[0].isIntersecting && C();
      },
      { root: h.current, threshold: 0.1 }
    );
    return T.observe(p.current), () => {
      p.current && T.unobserve(p.current);
    };
  }, [C, w, x]), Ee(() => {
    const T = H.filter(Oa).find((q) => q.id === N);
    o == null || o(T);
  }, [N]), /* @__PURE__ */ j(
    "div",
    {
      ref: h,
      className: "relative overflow-auto w-full h-[400px] customScroll",
      style: { paddingTop: rr, paddingLeft: rr },
      children: [
        /* @__PURE__ */ j(
          "div",
          {
            style: {
              height: Q.getTotalSize(),
              width: M.getTotalSize()
            },
            className: "relative",
            children: [
              _ && !x ? Array.from({ length: 10 }).map((T, q) => /* @__PURE__ */ b(
                "div",
                {
                  className: "absolute bg-background-tertiary animate-pulse rounded-md",
                  style: {
                    top: Math.floor(q / m) * (O + t),
                    left: q % m * (y + r),
                    height: O,
                    width: y
                  }
                },
                q
              )) : Q.getVirtualItems().map(
                (T) => M.getVirtualItems().map((q) => {
                  const ee = T.index * m + q.index, W = H[ee];
                  if (!W) return null;
                  let D = Math.floor(ee / m) * (O + t);
                  const A = ee % m * (y + r);
                  let Y = 0;
                  switch (m) {
                    case 1:
                      Y = 180;
                      break;
                    case 2:
                      Y = 80;
                      break;
                  }
                  return a && (D = D - Y), F === W ? ee === 0 ? /* @__PURE__ */ b(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: O - Y,
                        width: y * I.length + r * (I.length - 1)
                      },
                      children: a
                    },
                    W + ee
                  ) : null : /* @__PURE__ */ b(
                    Fa,
                    {
                      src: W.thumbnail ?? W.path ?? void 0,
                      alt: W.name,
                      name: W.name,
                      imageWidth: y,
                      imageHeight: y * 0.869,
                      secondaryText: W.type,
                      fileType: W.type,
                      style: {
                        top: D,
                        left: A,
                        height: O,
                        width: y
                      },
                      selected: N === W.id,
                      onSelect: (he) => {
                        R(he ? W.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          l ? /* @__PURE__ */ b(
                            Bo,
                            {
                              onClick: () => l(W)
                            },
                            "details"
                          ) : void 0,
                          c ? /* @__PURE__ */ b(
                            Ho,
                            {
                              onClick: () => c(W)
                            },
                            "delete"
                          ) : void 0,
                          u ? /* @__PURE__ */ b(
                            Vo,
                            {
                              onClick: () => u(W)
                            },
                            "rename"
                          ) : void 0,
                          d ? /* @__PURE__ */ b(
                            Wo,
                            {
                              onClick: () => d(W)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    W.id
                  );
                })
              ),
              w && /* @__PURE__ */ b("div", { ref: p, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ b("div", { className: "flex items-center justify-center w-full pt-4 h-11", children: x && /* @__PURE__ */ b(ra, {}) })
      ]
    }
  );
}
const ic = (i) => {
  const { fetcher: e } = vt({
    method: gt.post
  }), { fetcher: t } = vt({
    method: gt.post
  }), { fetcher: r } = vt({
    method: gt.delete
  });
  return {
    validateAndGetUploadOptions: async ({
      file: l,
      source: c,
      mimeType: u,
      cancelToken: d
    }) => await e(
      i != null && i.isCommon ? kl : i != null && i.isPublic ? Il : Pl,
      {
        source: c,
        fileName: l.name,
        fileSize: l.size,
        mimeType: u,
        isCommon: (i == null ? void 0 : i.isCommon) ?? !1
      },
      {
        cancelToken: d
      }
    ),
    uploadToFileStore: async ({
      file: l,
      uploadOptions: c,
      progressHandler: u,
      cancelToken: d
    }) => {
      const h = new FormData();
      return h.append("key", c.key), h.append("acl", c.acl), h.append("X-Amz-Credential", c.credential), h.append("X-Amz-Algorithm", c.algorithm), h.append("X-Amz-Date", c.date), h.append("Policy", c.policy), h.append("X-Amz-Signature", c.signature), h.append("Content-Type", c.contentType), h.append("Cache-Control", c.cacheControl), h.append("file", l), await pr.post(c.url, h, {
        onUploadProgress: u,
        cancelToken: d
      });
    },
    activate: async ({
      fileId: l,
      cancelToken: c
    }) => await t(
      i != null && i.isCommon ? Ml(l) : i != null && i.isPublic ? Ll(l) : Dl(l),
      {},
      {
        cancelToken: c,
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    removeDraftFile: async (l) => await r(i != null && i.isCommon ? Tl(l) : Fl(l))
  };
}, rc = () => {
  let i;
  return {
    createToken: () => (i = pr.CancelToken.source(), i.token),
    cancel: () => {
      i && (i.cancel(), i = void 0);
    },
    getToken: () => i == null ? void 0 : i.token
  };
}, sc = ({
  onChange: i
}) => {
  let e = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const t = () => {
    i(e);
  }, r = () => {
    e = {
      ...e,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, t();
  }, s = () => {
    e = {
      ...e,
      isUploading: !1,
      isUploaded: !0
    }, t();
  }, n = (l, c) => {
    c && (e = {
      ...e,
      progress: Math.round(l * 100 / c),
      total: c
    }, t());
  };
  return {
    getState: () => e,
    startProgress: r,
    finishProgress: s,
    updateProgress: n,
    resetProgress: () => {
      e = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, t();
    },
    progressHandler: (l) => {
      const c = l.loaded, u = l.total;
      n(c, u);
    }
  };
}, nc = (i) => {
  const e = i.name.match(/\.[a-zA-Z0-9_-]+$/i);
  switch (e && e[0]) {
    case ze.Docx:
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case ze.Doc:
      return "application/msword";
    case ze.Ttf:
      return "font/ttf";
    case ze.AD_PRT:
      return "application/vnd.alibre.part";
    case ze.AD_SMP:
      return "application/vnd.alibre.sheet_metal_part";
    case ze.AD_ASM:
      return "application/vnd.alibre.assembly";
    case ze.AD_DRW:
      return "application/vnd.alibre.drawing";
    default:
      return i.type;
  }
}, On = (i) => {
  const { t: e } = pe(), { validateAndGetUploadOptions: t, uploadToFileStore: r, activate: s, removeDraftFile: n } = ic(i);
  return {
    createFileUploader: (o) => {
      const l = sc({ onChange: o }), c = rc();
      return {
        progress: l,
        upload: async ({ file: h, source: p }) => {
          l.startProgress();
          const m = c.createToken();
          let v;
          try {
            const { uploadOptions: y, id: S } = await t({
              file: h,
              source: p,
              mimeType: nc(h),
              cancelToken: m
            });
            v = S, await r({
              file: h,
              uploadOptions: y,
              progressHandler: l.progressHandler,
              cancelToken: m
            });
            const O = await s({
              fileId: S,
              cancelToken: m
            });
            return l.finishProgress(), O[S];
          } catch (y) {
            if (pr.isCancel(y)) {
              be(e("file_manager.cancelled"));
              return;
            }
            throw typeof v == "number" ? await n(v) : be.error(e("file_manager.error")), y;
          }
        },
        cancelUpload: () => {
          c.cancel(), l.resetProgress();
        }
      };
    }
  };
}, ac = ({
  preLoadedFiles: i,
  source: e,
  fileManagerApiType: t,
  onChange: r
}) => {
  const { t: s } = pe(), { createFileUploader: n } = On(t), { deleteFile: a } = Cn(), [o, l] = V([]), [c, u] = V([]), [d, h] = V({}), [p, m] = V([]), v = (w) => {
    const x = i == null ? void 0 : i.map((_) => _.id);
    return x == null ? void 0 : x.includes(w.id);
  }, y = () => c.map((x) => {
    const _ = !v(x);
    return {
      file: { ...x, name: x.filename },
      disabled: p.includes(x.id),
      uploaded: _
    };
  }), S = () => Object.entries(d).map(([x, _]) => ({
    file: { ..._, id: x, name: _.file.name },
    progress: _.progress.isUploading ? _.progress.progress : void 0,
    uploaded: _.progress.isUploaded
  })), O = y(), E = S(), N = async (w) => {
    try {
      m((x) => [...x, w]), await a({ id: w }), u((x) => {
        const _ = x.filter((F) => F.id !== w);
        return r == null || r(_), _;
      });
    } catch (x) {
      throw x;
    } finally {
      m((x) => x.filter((_) => _ !== w));
    }
  }, R = (w) => {
    d[w].cancelUpload(), h((x) => {
      const { [w]: _, ...F } = x;
      return F;
    });
  };
  return {
    waitingUploadFiles: o,
    setWaitingUploadFiles: l,
    removingFiles: p,
    uploadedFiles: c,
    setUploadedFiles: u,
    mappedUploadedFiles: O,
    mappedUploadingFiles: E,
    startUploading: async (w) => {
      const x = await zo(w) + "_" + crypto.randomUUID(), F = n((I) => {
        h((H) => ({
          ...H,
          [x]: {
            ...H[x],
            progress: I
          }
        }));
      });
      l((I) => I.filter((H) => H.file !== w)), h((I) => ({
        ...I,
        [x]: {
          file: w,
          progress: F.progress.getState(),
          cancelUpload: F.cancelUpload
        }
      }));
      try {
        const I = await F.upload({
          file: w,
          source: e
        });
        if (I)
          return u((H) => {
            const U = [{ ...I, file: w }, ...H];
            return r == null || r(U), U;
          }), I;
      } catch (I) {
        const H = I instanceof Error ? I : new Error(s("file_manager.error"));
        throw l((U) => [{ file: w, error: H }, ...U]), I;
      } finally {
        h((I) => {
          const { [x]: H, ...U } = I;
          return U;
        });
      }
    },
    deleteUploadedOrUploadingFile: async (w) => {
      d[w] && await R(String(w)), c.find((F) => F.id === +w) && await N(Number(w));
    },
    deleteUploadedFile: N,
    deleteUploadingFile: R
  };
}, oc = (i) => i instanceof File, lc = (i) => "id" in i && "file" in i, cc = (i) => "id" in i && "path" in i && "size" in i && "type" in i && "filename" in i && "thumbnail" in i, uc = ({ progress: i }) => {
  const t = 2 * Math.PI * 14, r = t * (1 - i / 100);
  return /* @__PURE__ */ j("div", { className: "relative w-8 h-8", children: [
    /* @__PURE__ */ b("svg", { className: "w-full h-full", children: /* @__PURE__ */ b(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-text-secondary fill-none",
        strokeWidth: "3"
      }
    ) }),
    /* @__PURE__ */ b("svg", { className: "absolute top-0 left-0 w-full h-full", children: /* @__PURE__ */ b(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-background-secondary fill-none transition-all duration-300",
        strokeWidth: "3",
        strokeDasharray: t,
        strokeDashoffset: r,
        transform: "rotate(-90 16 16)"
      }
    ) })
  ] });
};
function Ii({
  file: i,
  progress: e = 0,
  isError: t,
  isLoading: r,
  isLoaded: s,
  isDeleting: n,
  className: a,
  disabled: o,
  disabledDeleteButton: l,
  showDeleteButton: c,
  showEditButton: u,
  onDeleteFile: d,
  onEdit: h
}) {
  return /* @__PURE__ */ j(
    "div",
    {
      className: ie("relative w-24 h-24", a),
      onClick: (p) => p.stopPropagation(),
      children: [
        c && /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            className: ie(
              "absolute group -top-2 -right-2 z-1 rounded-full bg-background-primary",
              n && "animate-pulse"
            ),
            onClick: (p) => {
              p.preventDefault(), p.stopPropagation(), d();
            },
            disabled: l || o,
            children: /* @__PURE__ */ b(
              Ar,
              {
                className: ie(
                  "fill-text-secondary transition-colors",
                  !l && !o && "group-hover:fill-brand-primary"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ j("div", { className: "relative w-full h-full group/edit", children: [
          i instanceof File ? /* @__PURE__ */ b(nn, { file: i, className: "w-full h-full rounded-md" }) : /* @__PURE__ */ b(
            ot,
            {
              src: i.thumbnail || i.path,
              fileType: i.type,
              isThumbnail: !0,
              className: "w-full h-full rounded-md",
              title: i.filename
            }
          ),
          /* @__PURE__ */ b(
            "div",
            {
              className: ie(
                "absolute top-0 left-0 w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md cursor-auto hidden",
                u && !o && "flex lg:hidden group-hover/edit:lg:flex"
              ),
              children: /* @__PURE__ */ b("div", { onClick: h, className: "cursor-pointer group p-2", children: /* @__PURE__ */ b(ga, { className: "fill-background-secondary group-hover:fill-brand-primary transition-colors" }) })
            }
          )
        ] }),
        t && /* @__PURE__ */ b("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ b(Ar, { className: "fill-danger rounded-full" }) }),
        r && /* @__PURE__ */ b("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ b(uc, { progress: e }) })
      ]
    }
  );
}
var En = /* @__PURE__ */ ((i) => (i[i.Small = 0] = "Small", i[i.Medium = 1] = "Medium", i[i.Big = 2] = "Big", i))(En || {});
const hc = {
  0: "p-2",
  1: "p-3",
  2: "p-10"
};
function Nn({
  acceptTypes: i,
  children: e,
  dropZoneClassName: t,
  className: r,
  disabled: s,
  error: n,
  variant: a = En.Medium,
  label: o,
  icon: l = /* @__PURE__ */ b(va, {}),
  isPreFetching: c,
  toastText: u,
  labelClassName: d,
  openNativeWindow: h = !0,
  onSelectFile: p,
  onClick: m
}) {
  const { t: v } = pe(), y = we(null), [S, O] = V(!1), [E, N] = V(""), R = (_) => {
    var F;
    _.preventDefault(), !s && (m == null || m(), h && ((F = y.current) == null || F.click()));
  }, g = (_) => {
    if (_.target.files && _.target.files[0]) {
      const F = _.target.files[0];
      i && !as(F.type, i) ? N(v("file_manager.file_upload.file_not_supported")) : (p(F), u && be.success(u));
    }
    _.target.value = "";
  }, C = (_) => {
    _.preventDefault(), O(!0);
  }, w = (_) => {
    _.preventDefault(), O(!1);
  }, x = (_) => {
    _.preventDefault(), _.stopPropagation();
    const { files: F } = _.dataTransfer;
    if (F && F.length) {
      const I = F[0];
      i && !as(I.type, i) ? N(v("file_manager.file_upload.file_not_supported")) : (p(I), u && be.success(u));
    }
    O(!1);
  };
  return /* @__PURE__ */ j("div", { className: ie("font-medium", r), children: [
    /* @__PURE__ */ b(
      "input",
      {
        ref: y,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: g,
        disabled: c || s,
        accept: i && Uo(i)
      }
    ),
    /* @__PURE__ */ j(
      "button",
      {
        type: "button",
        className: ie(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          S ? "border-brand-primary" : "border-text-secondary",
          hc[a],
          c && "animate-pulse",
          s || c ? "pointer-events-none" : "hover:border-brand-primary cursor-pointer",
          t
        ),
        onDragStart: C,
        onDragLeave: w,
        onDrop: x,
        onDragOver: C,
        onClick: R,
        children: [
          !!ua.count(e) && /* @__PURE__ */ b("div", { className: "flex w-full flex-wrap gap-3", children: e }),
          /* @__PURE__ */ j(
            "div",
            {
              className: ie(
                "flex w-full flex-col items-center justify-center gap-1",
                d
              ),
              children: [
                l,
                o ?? v("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ b(ui, { error: E, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ b(ui, { error: n, errorClassName: "text-center mt-2" })
  ] });
}
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function vs(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function _n(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vs(Object(t), !0).forEach(function(r) {
      mc(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : vs(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
function dc(i, e) {
  if (typeof i != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(i, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(i);
}
function Rn(i) {
  var e = dc(i, "string");
  return typeof e == "symbol" ? e : e + "";
}
function sr(i) {
  "@babel/helpers - typeof";
  return sr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sr(i);
}
function fc(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ys(i, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, Rn(r.key), r);
  }
}
function pc(i, e, t) {
  return e && ys(i.prototype, e), t && ys(i, t), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function mc(i, e, t) {
  return e = Rn(e), e in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function Pn(i) {
  return gc(i) || vc(i) || yc(i) || bc();
}
function gc(i) {
  if (Array.isArray(i)) return nr(i);
}
function vc(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function yc(i, e) {
  if (i) {
    if (typeof i == "string") return nr(i, e);
    var t = Object.prototype.toString.call(i).slice(8, -1);
    if (t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set") return Array.from(i);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return nr(i, e);
  }
}
function nr(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = i[t];
  return r;
}
function bc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Ei = typeof window < "u" && typeof window.document < "u", Te = Ei ? window : {}, Cr = Ei && Te.document.documentElement ? "ontouchstart" in Te.document.documentElement : !1, Sr = Ei ? "PointerEvent" in Te : !1, J = "cropper", Or = "all", Dn = "crop", Fn = "move", In = "zoom", Ge = "e", Je = "w", ft = "s", je = "n", jt = "ne", zt = "nw", Ut = "se", $t = "sw", ar = "".concat(J, "-crop"), bs = "".concat(J, "-disabled"), ve = "".concat(J, "-hidden"), ws = "".concat(J, "-hide"), wc = "".concat(J, "-invisible"), yi = "".concat(J, "-modal"), or = "".concat(J, "-move"), Yt = "".concat(J, "Action"), li = "".concat(J, "Preview"), Er = "crop", Ln = "move", kn = "none", lr = "crop", cr = "cropend", ur = "cropmove", hr = "cropstart", xs = "dblclick", xc = Cr ? "touchstart" : "mousedown", Cc = Cr ? "touchmove" : "mousemove", Sc = Cr ? "touchend touchcancel" : "mouseup", Cs = Sr ? "pointerdown" : xc, Ss = Sr ? "pointermove" : Cc, Os = Sr ? "pointerup pointercancel" : Sc, Es = "ready", Ns = "resize", _s = "wheel", dr = "zoom", Rs = "image/jpeg", Oc = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Ec = /^data:/, Nc = /^data:image\/jpeg;base64,/, _c = /^img|canvas$/i, Mn = 200, Tn = 100, Ps = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: Er,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: Mn,
  minContainerHeight: Tn,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Rc = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Pc = Number.isNaN || Te.isNaN;
function z(i) {
  return typeof i == "number" && !Pc(i);
}
var Ds = function(e) {
  return e > 0 && e < 1 / 0;
};
function Li(i) {
  return typeof i > "u";
}
function ct(i) {
  return sr(i) === "object" && i !== null;
}
var Dc = Object.prototype.hasOwnProperty;
function pt(i) {
  if (!ct(i))
    return !1;
  try {
    var e = i.constructor, t = e.prototype;
    return e && t && Dc.call(t, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function ge(i) {
  return typeof i == "function";
}
var Fc = Array.prototype.slice;
function An(i) {
  return Array.from ? Array.from(i) : Fc.call(i);
}
function ne(i, e) {
  return i && ge(e) && (Array.isArray(i) || z(i.length) ? An(i).forEach(function(t, r) {
    e.call(i, t, r, i);
  }) : ct(i) && Object.keys(i).forEach(function(t) {
    e.call(i, i[t], t, i);
  })), i;
}
var Z = Object.assign || function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
    r[s - 1] = arguments[s];
  return ct(e) && r.length > 0 && r.forEach(function(n) {
    ct(n) && Object.keys(n).forEach(function(a) {
      e[a] = n[a];
    });
  }), e;
}, Ic = /\.\d*(?:0|9){12}\d*$/;
function bt(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Ic.test(i) ? Math.round(i * e) / e : i;
}
var Lc = /^width|height|left|top|marginLeft|marginTop$/;
function qe(i, e) {
  var t = i.style;
  ne(e, function(r, s) {
    Lc.test(s) && z(r) && (r = "".concat(r, "px")), t[s] = r;
  });
}
function kc(i, e) {
  return i.classList ? i.classList.contains(e) : i.className.indexOf(e) > -1;
}
function oe(i, e) {
  if (e) {
    if (z(i.length)) {
      ne(i, function(r) {
        oe(r, e);
      });
      return;
    }
    if (i.classList) {
      i.classList.add(e);
      return;
    }
    var t = i.className.trim();
    t ? t.indexOf(e) < 0 && (i.className = "".concat(t, " ").concat(e)) : i.className = e;
  }
}
function Me(i, e) {
  if (e) {
    if (z(i.length)) {
      ne(i, function(t) {
        Me(t, e);
      });
      return;
    }
    if (i.classList) {
      i.classList.remove(e);
      return;
    }
    i.className.indexOf(e) >= 0 && (i.className = i.className.replace(e, ""));
  }
}
function mt(i, e, t) {
  if (e) {
    if (z(i.length)) {
      ne(i, function(r) {
        mt(r, e, t);
      });
      return;
    }
    t ? oe(i, e) : Me(i, e);
  }
}
var Mc = /([a-z\d])([A-Z])/g;
function Nr(i) {
  return i.replace(Mc, "$1-$2").toLowerCase();
}
function fr(i, e) {
  return ct(i[e]) ? i[e] : i.dataset ? i.dataset[e] : i.getAttribute("data-".concat(Nr(e)));
}
function Xt(i, e, t) {
  ct(t) ? i[e] = t : i.dataset ? i.dataset[e] = t : i.setAttribute("data-".concat(Nr(e)), t);
}
function Tc(i, e) {
  if (ct(i[e]))
    try {
      delete i[e];
    } catch {
      i[e] = void 0;
    }
  else if (i.dataset)
    try {
      delete i.dataset[e];
    } catch {
      i.dataset[e] = void 0;
    }
  else
    i.removeAttribute("data-".concat(Nr(e)));
}
var jn = /\s\s*/, zn = (function() {
  var i = !1;
  if (Ei) {
    var e = !1, t = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return i = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(n) {
        e = n;
      }
    });
    Te.addEventListener("test", t, r), Te.removeEventListener("test", t, r);
  }
  return i;
})();
function _e(i, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = t;
  e.trim().split(jn).forEach(function(n) {
    if (!zn) {
      var a = i.listeners;
      a && a[n] && a[n][t] && (s = a[n][t], delete a[n][t], Object.keys(a[n]).length === 0 && delete a[n], Object.keys(a).length === 0 && delete i.listeners);
    }
    i.removeEventListener(n, s, r);
  });
}
function xe(i, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = t;
  e.trim().split(jn).forEach(function(n) {
    if (r.once && !zn) {
      var a = i.listeners, o = a === void 0 ? {} : a;
      s = function() {
        delete o[n][t], i.removeEventListener(n, s, r);
        for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
          u[d] = arguments[d];
        t.apply(i, u);
      }, o[n] || (o[n] = {}), o[n][t] && i.removeEventListener(n, o[n][t], r), o[n][t] = s, i.listeners = o;
    }
    i.addEventListener(n, s, r);
  });
}
function wt(i, e, t) {
  var r;
  return ge(Event) && ge(CustomEvent) ? r = new CustomEvent(e, {
    detail: t,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(e, !0, !0, t)), i.dispatchEvent(r);
}
function Un(i) {
  var e = i.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var ki = Te.location, Ac = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Fs(i) {
  var e = i.match(Ac);
  return e !== null && (e[1] !== ki.protocol || e[2] !== ki.hostname || e[3] !== ki.port);
}
function Is(i) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return i + (i.indexOf("?") === -1 ? "?" : "&") + e;
}
function Vt(i) {
  var e = i.rotate, t = i.scaleX, r = i.scaleY, s = i.translateX, n = i.translateY, a = [];
  z(s) && s !== 0 && a.push("translateX(".concat(s, "px)")), z(n) && n !== 0 && a.push("translateY(".concat(n, "px)")), z(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), z(t) && t !== 1 && a.push("scaleX(".concat(t, ")")), z(r) && r !== 1 && a.push("scaleY(".concat(r, ")"));
  var o = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: o,
    msTransform: o,
    transform: o
  };
}
function jc(i) {
  var e = _n({}, i), t = 0;
  return ne(i, function(r, s) {
    delete e[s], ne(e, function(n) {
      var a = Math.abs(r.startX - n.startX), o = Math.abs(r.startY - n.startY), l = Math.abs(r.endX - n.endX), c = Math.abs(r.endY - n.endY), u = Math.sqrt(a * a + o * o), d = Math.sqrt(l * l + c * c), h = (d - u) / u;
      Math.abs(h) > Math.abs(t) && (t = h);
    });
  }), t;
}
function ci(i, e) {
  var t = i.pageX, r = i.pageY, s = {
    endX: t,
    endY: r
  };
  return e ? s : _n({
    startX: t,
    startY: r
  }, s);
}
function zc(i) {
  var e = 0, t = 0, r = 0;
  return ne(i, function(s) {
    var n = s.startX, a = s.startY;
    e += n, t += a, r += 1;
  }), e /= r, t /= r, {
    pageX: e,
    pageY: t
  };
}
function Ye(i) {
  var e = i.aspectRatio, t = i.height, r = i.width, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", n = Ds(r), a = Ds(t);
  if (n && a) {
    var o = t * e;
    s === "contain" && o > r || s === "cover" && o < r ? t = r / e : r = t * e;
  } else n ? t = r / e : a && (r = t * e);
  return {
    width: r,
    height: t
  };
}
function Uc(i) {
  var e = i.width, t = i.height, r = i.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: t,
      height: e
    };
  var s = r % 90 * Math.PI / 180, n = Math.sin(s), a = Math.cos(s), o = e * a + t * n, l = e * n + t * a;
  return r > 90 ? {
    width: l,
    height: o
  } : {
    width: o,
    height: l
  };
}
function $c(i, e, t, r) {
  var s = e.aspectRatio, n = e.naturalWidth, a = e.naturalHeight, o = e.rotate, l = o === void 0 ? 0 : o, c = e.scaleX, u = c === void 0 ? 1 : c, d = e.scaleY, h = d === void 0 ? 1 : d, p = t.aspectRatio, m = t.naturalWidth, v = t.naturalHeight, y = r.fillColor, S = y === void 0 ? "transparent" : y, O = r.imageSmoothingEnabled, E = O === void 0 ? !0 : O, N = r.imageSmoothingQuality, R = N === void 0 ? "low" : N, g = r.maxWidth, C = g === void 0 ? 1 / 0 : g, w = r.maxHeight, x = w === void 0 ? 1 / 0 : w, _ = r.minWidth, F = _ === void 0 ? 0 : _, I = r.minHeight, H = I === void 0 ? 0 : I, U = document.createElement("canvas"), Q = U.getContext("2d"), M = Ye({
    aspectRatio: p,
    width: C,
    height: x
  }), ae = Ye({
    aspectRatio: p,
    width: F,
    height: H
  }, "cover"), T = Math.min(M.width, Math.max(ae.width, m)), q = Math.min(M.height, Math.max(ae.height, v)), ee = Ye({
    aspectRatio: s,
    width: C,
    height: x
  }), W = Ye({
    aspectRatio: s,
    width: F,
    height: H
  }, "cover"), D = Math.min(ee.width, Math.max(W.width, n)), A = Math.min(ee.height, Math.max(W.height, a)), Y = [-D / 2, -A / 2, D, A];
  return U.width = bt(T), U.height = bt(q), Q.fillStyle = S, Q.fillRect(0, 0, T, q), Q.save(), Q.translate(T / 2, q / 2), Q.rotate(l * Math.PI / 180), Q.scale(u, h), Q.imageSmoothingEnabled = E, Q.imageSmoothingQuality = R, Q.drawImage.apply(Q, [i].concat(Pn(Y.map(function(he) {
    return Math.floor(bt(he));
  })))), Q.restore(), U;
}
var $n = String.fromCharCode;
function Bc(i, e, t) {
  var r = "";
  t += e;
  for (var s = e; s < t; s += 1)
    r += $n(i.getUint8(s));
  return r;
}
var Hc = /^data:.*,/;
function Vc(i) {
  var e = i.replace(Hc, ""), t = atob(e), r = new ArrayBuffer(t.length), s = new Uint8Array(r);
  return ne(s, function(n, a) {
    s[a] = t.charCodeAt(a);
  }), r;
}
function Wc(i, e) {
  for (var t = [], r = 8192, s = new Uint8Array(i); s.length > 0; )
    t.push($n.apply(null, An(s.subarray(0, r)))), s = s.subarray(r);
  return "data:".concat(e, ";base64,").concat(btoa(t.join("")));
}
function Kc(i) {
  var e = new DataView(i), t;
  try {
    var r, s, n;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, o = 2; o + 1 < a; ) {
        if (e.getUint8(o) === 255 && e.getUint8(o + 1) === 225) {
          s = o;
          break;
        }
        o += 1;
      }
    if (s) {
      var l = s + 4, c = s + 10;
      if (Bc(e, l, 4) === "Exif") {
        var u = e.getUint16(c);
        if (r = u === 18761, (r || u === 19789) && e.getUint16(c + 2, r) === 42) {
          var d = e.getUint32(c + 4, r);
          d >= 8 && (n = c + d);
        }
      }
    }
    if (n) {
      var h = e.getUint16(n, r), p, m;
      for (m = 0; m < h; m += 1)
        if (p = n + m * 12 + 2, e.getUint16(p, r) === 274) {
          p += 8, t = e.getUint16(p, r), e.setUint16(p, 1, r);
          break;
        }
    }
  } catch {
    t = 1;
  }
  return t;
}
function Qc(i) {
  var e = 0, t = 1, r = 1;
  switch (i) {
    // Flip horizontal
    case 2:
      t = -1;
      break;
    // Rotate left 180°
    case 3:
      e = -180;
      break;
    // Flip vertical
    case 4:
      r = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      e = 90, r = -1;
      break;
    // Rotate right 90°
    case 6:
      e = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      e = 90, t = -1;
      break;
    // Rotate left 90°
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: t,
    scaleY: r
  };
}
var qc = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, r = this.container, s = this.cropper, n = Number(t.minContainerWidth), a = Number(t.minContainerHeight);
    oe(s, ve), Me(e, ve);
    var o = {
      width: Math.max(r.offsetWidth, n >= 0 ? n : Mn),
      height: Math.max(r.offsetHeight, a >= 0 ? a : Tn)
    };
    this.containerData = o, qe(s, {
      width: o.width,
      height: o.height
    }), oe(e, ve), Me(s, ve);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, r = this.options.viewMode, s = Math.abs(t.rotate) % 180 === 90, n = s ? t.naturalHeight : t.naturalWidth, a = s ? t.naturalWidth : t.naturalHeight, o = n / a, l = e.width, c = e.height;
    e.height * o > e.width ? r === 3 ? l = e.height * o : c = e.width / o : r === 3 ? c = e.width / o : l = e.height * o;
    var u = {
      aspectRatio: o,
      naturalWidth: n,
      naturalHeight: a,
      width: l,
      height: c
    };
    this.canvasData = u, this.limited = r === 1 || r === 2, this.limitCanvas(!0, !0), u.width = Math.min(Math.max(u.width, u.minWidth), u.maxWidth), u.height = Math.min(Math.max(u.height, u.minHeight), u.maxHeight), u.left = (e.width - u.width) / 2, u.top = (e.height - u.height) / 2, u.oldLeft = u.left, u.oldTop = u.top, this.initialCanvasData = Z({}, u);
  },
  limitCanvas: function(e, t) {
    var r = this.options, s = this.containerData, n = this.canvasData, a = this.cropBoxData, o = r.viewMode, l = n.aspectRatio, c = this.cropped && a;
    if (e) {
      var u = Number(r.minCanvasWidth) || 0, d = Number(r.minCanvasHeight) || 0;
      o > 1 ? (u = Math.max(u, s.width), d = Math.max(d, s.height), o === 3 && (d * l > u ? u = d * l : d = u / l)) : o > 0 && (u ? u = Math.max(u, c ? a.width : 0) : d ? d = Math.max(d, c ? a.height : 0) : c && (u = a.width, d = a.height, d * l > u ? u = d * l : d = u / l));
      var h = Ye({
        aspectRatio: l,
        width: u,
        height: d
      });
      u = h.width, d = h.height, n.minWidth = u, n.minHeight = d, n.maxWidth = 1 / 0, n.maxHeight = 1 / 0;
    }
    if (t)
      if (o > (c ? 0 : 1)) {
        var p = s.width - n.width, m = s.height - n.height;
        n.minLeft = Math.min(0, p), n.minTop = Math.min(0, m), n.maxLeft = Math.max(0, p), n.maxTop = Math.max(0, m), c && this.limited && (n.minLeft = Math.min(a.left, a.left + (a.width - n.width)), n.minTop = Math.min(a.top, a.top + (a.height - n.height)), n.maxLeft = a.left, n.maxTop = a.top, o === 2 && (n.width >= s.width && (n.minLeft = Math.min(0, p), n.maxLeft = Math.max(0, p)), n.height >= s.height && (n.minTop = Math.min(0, m), n.maxTop = Math.max(0, m))));
      } else
        n.minLeft = -n.width, n.minTop = -n.height, n.maxLeft = s.width, n.maxTop = s.height;
  },
  renderCanvas: function(e, t) {
    var r = this.canvasData, s = this.imageData;
    if (t) {
      var n = Uc({
        width: s.naturalWidth * Math.abs(s.scaleX || 1),
        height: s.naturalHeight * Math.abs(s.scaleY || 1),
        degree: s.rotate || 0
      }), a = n.width, o = n.height, l = r.width * (a / r.naturalWidth), c = r.height * (o / r.naturalHeight);
      r.left -= (l - r.width) / 2, r.top -= (c - r.height) / 2, r.width = l, r.height = c, r.aspectRatio = a / o, r.naturalWidth = a, r.naturalHeight = o, this.limitCanvas(!0, !1);
    }
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCanvas(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, qe(this.canvas, Z({
      width: r.width,
      height: r.height
    }, Vt({
      translateX: r.left,
      translateY: r.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, r = this.imageData, s = r.naturalWidth * (t.width / t.naturalWidth), n = r.naturalHeight * (t.height / t.naturalHeight);
    Z(r, {
      width: s,
      height: n,
      left: (t.width - s) / 2,
      top: (t.height - n) / 2
    }), qe(this.image, Z({
      width: r.width,
      height: r.height
    }, Vt(Z({
      translateX: r.left,
      translateY: r.top
    }, r)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, r = e.aspectRatio || e.initialAspectRatio, s = Number(e.autoCropArea) || 0.8, n = {
      width: t.width,
      height: t.height
    };
    r && (t.height * r > t.width ? n.height = n.width / r : n.width = n.height * r), this.cropBoxData = n, this.limitCropBox(!0, !0), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), n.width = Math.max(n.minWidth, n.width * s), n.height = Math.max(n.minHeight, n.height * s), n.left = t.left + (t.width - n.width) / 2, n.top = t.top + (t.height - n.height) / 2, n.oldLeft = n.left, n.oldTop = n.top, this.initialCropBoxData = Z({}, n);
  },
  limitCropBox: function(e, t) {
    var r = this.options, s = this.containerData, n = this.canvasData, a = this.cropBoxData, o = this.limited, l = r.aspectRatio;
    if (e) {
      var c = Number(r.minCropBoxWidth) || 0, u = Number(r.minCropBoxHeight) || 0, d = o ? Math.min(s.width, n.width, n.width + n.left, s.width - n.left) : s.width, h = o ? Math.min(s.height, n.height, n.height + n.top, s.height - n.top) : s.height;
      c = Math.min(c, s.width), u = Math.min(u, s.height), l && (c && u ? u * l > c ? u = c / l : c = u * l : c ? u = c / l : u && (c = u * l), h * l > d ? h = d / l : d = h * l), a.minWidth = Math.min(c, d), a.minHeight = Math.min(u, h), a.maxWidth = d, a.maxHeight = h;
    }
    t && (o ? (a.minLeft = Math.max(0, n.left), a.minTop = Math.max(0, n.top), a.maxLeft = Math.min(s.width, n.left + n.width) - a.width, a.maxTop = Math.min(s.height, n.top + n.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = s.width - a.width, a.maxTop = s.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, r = this.cropBoxData;
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCropBox(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, e.movable && e.cropBoxMovable && Xt(this.face, Yt, r.width >= t.width && r.height >= t.height ? Fn : Or), qe(this.cropBox, Z({
      width: r.width,
      height: r.height
    }, Vt({
      translateX: r.left,
      translateY: r.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), wt(this.element, lr, this.getData());
  }
}, Yc = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, r = this.options.preview, s = t ? this.crossOriginUrl : this.url, n = e.alt || "The image to preview", a = document.createElement("img");
    if (t && (a.crossOrigin = t), a.src = s, a.alt = n, this.viewBox.appendChild(a), this.viewBoxImage = a, !!r) {
      var o = r;
      typeof r == "string" ? o = e.ownerDocument.querySelectorAll(r) : r.querySelector && (o = [r]), this.previews = o, ne(o, function(l) {
        var c = document.createElement("img");
        Xt(l, li, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), t && (c.crossOrigin = t), c.src = s, c.alt = n, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    ne(this.previews, function(e) {
      var t = fr(e, li);
      qe(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, Tc(e, li);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, r = this.cropBoxData, s = r.width, n = r.height, a = e.width, o = e.height, l = r.left - t.left - e.left, c = r.top - t.top - e.top;
    !this.cropped || this.disabled || (qe(this.viewBoxImage, Z({
      width: a,
      height: o
    }, Vt(Z({
      translateX: -l,
      translateY: -c
    }, e)))), ne(this.previews, function(u) {
      var d = fr(u, li), h = d.width, p = d.height, m = h, v = p, y = 1;
      s && (y = h / s, v = n * y), n && v > p && (y = p / n, m = s * y, v = p), qe(u, {
        width: m,
        height: v
      }), qe(u.getElementsByTagName("img")[0], Z({
        width: a * y,
        height: o * y
      }, Vt(Z({
        translateX: -l * y,
        translateY: -c * y
      }, e))));
    }));
  }
}, Xc = {
  bind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    ge(t.cropstart) && xe(e, hr, t.cropstart), ge(t.cropmove) && xe(e, ur, t.cropmove), ge(t.cropend) && xe(e, cr, t.cropend), ge(t.crop) && xe(e, lr, t.crop), ge(t.zoom) && xe(e, dr, t.zoom), xe(r, Cs, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && xe(r, _s, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && xe(r, xs, this.onDblclick = this.dblclick.bind(this)), xe(e.ownerDocument, Ss, this.onCropMove = this.cropMove.bind(this)), xe(e.ownerDocument, Os, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && xe(window, Ns, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    ge(t.cropstart) && _e(e, hr, t.cropstart), ge(t.cropmove) && _e(e, ur, t.cropmove), ge(t.cropend) && _e(e, cr, t.cropend), ge(t.crop) && _e(e, lr, t.crop), ge(t.zoom) && _e(e, dr, t.zoom), _e(r, Cs, this.onCropStart), t.zoomable && t.zoomOnWheel && _e(r, _s, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && _e(r, xs, this.onDblclick), _e(e.ownerDocument, Ss, this.onCropMove), _e(e.ownerDocument, Os, this.onCropEnd), t.responsive && _e(window, Ns, this.onResize);
  }
}, Gc = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, r = this.containerData, s = t.offsetWidth / r.width, n = t.offsetHeight / r.height, a = Math.abs(s - 1) > Math.abs(n - 1) ? s : n;
      if (a !== 1) {
        var o, l;
        e.restore && (o = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(ne(o, function(c, u) {
          o[u] = c * a;
        })), this.setCropBoxData(ne(l, function(c, u) {
          l[u] = c * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === kn || this.setDragMode(kc(this.dragBox, ar) ? Ln : Er);
  },
  wheel: function(e) {
    var t = this, r = Number(this.options.wheelZoomRatio) || 0.1, s = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? s = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? s = -e.wheelDelta / 120 : e.detail && (s = e.detail > 0 ? 1 : -1), this.zoom(-s * r, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, r = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (z(t) && t !== 1 || z(r) && r !== 0 || e.ctrlKey))) {
      var s = this.options, n = this.pointers, a;
      e.changedTouches ? ne(e.changedTouches, function(o) {
        n[o.identifier] = ci(o);
      }) : n[e.pointerId || 0] = ci(e), Object.keys(n).length > 1 && s.zoomable && s.zoomOnTouch ? a = In : a = fr(e.target, Yt), Oc.test(a) && wt(this.element, hr, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === Dn && (this.cropping = !0, oe(this.dragBox, yi)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var r = this.pointers;
      e.preventDefault(), wt(this.element, ur, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? ne(e.changedTouches, function(s) {
        Z(r[s.identifier] || {}, ci(s, !0));
      }) : Z(r[e.pointerId || 0] || {}, ci(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, r = this.pointers;
      e.changedTouches ? ne(e.changedTouches, function(s) {
        delete r[s.identifier];
      }) : delete r[e.pointerId || 0], t && (e.preventDefault(), Object.keys(r).length || (this.action = ""), this.cropping && (this.cropping = !1, mt(this.dragBox, yi, this.cropped && this.options.modal)), wt(this.element, cr, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, Jc = {
  change: function(e) {
    var t = this.options, r = this.canvasData, s = this.containerData, n = this.cropBoxData, a = this.pointers, o = this.action, l = t.aspectRatio, c = n.left, u = n.top, d = n.width, h = n.height, p = c + d, m = u + h, v = 0, y = 0, S = s.width, O = s.height, E = !0, N;
    !l && e.shiftKey && (l = d && h ? d / h : 1), this.limited && (v = n.minLeft, y = n.minTop, S = v + Math.min(s.width, r.width, r.left + r.width), O = y + Math.min(s.height, r.height, r.top + r.height));
    var R = a[Object.keys(a)[0]], g = {
      x: R.endX - R.startX,
      y: R.endY - R.startY
    }, C = function(x) {
      switch (x) {
        case Ge:
          p + g.x > S && (g.x = S - p);
          break;
        case Je:
          c + g.x < v && (g.x = v - c);
          break;
        case je:
          u + g.y < y && (g.y = y - u);
          break;
        case ft:
          m + g.y > O && (g.y = O - m);
          break;
      }
    };
    switch (o) {
      // Move crop box
      case Or:
        c += g.x, u += g.y;
        break;
      // Resize crop box
      case Ge:
        if (g.x >= 0 && (p >= S || l && (u <= y || m >= O))) {
          E = !1;
          break;
        }
        C(Ge), d += g.x, d < 0 && (o = Je, d = -d, c -= d), l && (h = d / l, u += (n.height - h) / 2);
        break;
      case je:
        if (g.y <= 0 && (u <= y || l && (c <= v || p >= S))) {
          E = !1;
          break;
        }
        C(je), h -= g.y, u += g.y, h < 0 && (o = ft, h = -h, u -= h), l && (d = h * l, c += (n.width - d) / 2);
        break;
      case Je:
        if (g.x <= 0 && (c <= v || l && (u <= y || m >= O))) {
          E = !1;
          break;
        }
        C(Je), d -= g.x, c += g.x, d < 0 && (o = Ge, d = -d, c -= d), l && (h = d / l, u += (n.height - h) / 2);
        break;
      case ft:
        if (g.y >= 0 && (m >= O || l && (c <= v || p >= S))) {
          E = !1;
          break;
        }
        C(ft), h += g.y, h < 0 && (o = je, h = -h, u -= h), l && (d = h * l, c += (n.width - d) / 2);
        break;
      case jt:
        if (l) {
          if (g.y <= 0 && (u <= y || p >= S)) {
            E = !1;
            break;
          }
          C(je), h -= g.y, u += g.y, d = h * l;
        } else
          C(je), C(Ge), g.x >= 0 ? p < S ? d += g.x : g.y <= 0 && u <= y && (E = !1) : d += g.x, g.y <= 0 ? u > y && (h -= g.y, u += g.y) : (h -= g.y, u += g.y);
        d < 0 && h < 0 ? (o = $t, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = zt, d = -d, c -= d) : h < 0 && (o = Ut, h = -h, u -= h);
        break;
      case zt:
        if (l) {
          if (g.y <= 0 && (u <= y || c <= v)) {
            E = !1;
            break;
          }
          C(je), h -= g.y, u += g.y, d = h * l, c += n.width - d;
        } else
          C(je), C(Je), g.x <= 0 ? c > v ? (d -= g.x, c += g.x) : g.y <= 0 && u <= y && (E = !1) : (d -= g.x, c += g.x), g.y <= 0 ? u > y && (h -= g.y, u += g.y) : (h -= g.y, u += g.y);
        d < 0 && h < 0 ? (o = Ut, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = jt, d = -d, c -= d) : h < 0 && (o = $t, h = -h, u -= h);
        break;
      case $t:
        if (l) {
          if (g.x <= 0 && (c <= v || m >= O)) {
            E = !1;
            break;
          }
          C(Je), d -= g.x, c += g.x, h = d / l;
        } else
          C(ft), C(Je), g.x <= 0 ? c > v ? (d -= g.x, c += g.x) : g.y >= 0 && m >= O && (E = !1) : (d -= g.x, c += g.x), g.y >= 0 ? m < O && (h += g.y) : h += g.y;
        d < 0 && h < 0 ? (o = jt, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = Ut, d = -d, c -= d) : h < 0 && (o = zt, h = -h, u -= h);
        break;
      case Ut:
        if (l) {
          if (g.x >= 0 && (p >= S || m >= O)) {
            E = !1;
            break;
          }
          C(Ge), d += g.x, h = d / l;
        } else
          C(ft), C(Ge), g.x >= 0 ? p < S ? d += g.x : g.y >= 0 && m >= O && (E = !1) : d += g.x, g.y >= 0 ? m < O && (h += g.y) : h += g.y;
        d < 0 && h < 0 ? (o = zt, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = $t, d = -d, c -= d) : h < 0 && (o = jt, h = -h, u -= h);
        break;
      // Move canvas
      case Fn:
        this.move(g.x, g.y), E = !1;
        break;
      // Zoom canvas
      case In:
        this.zoom(jc(a), e), E = !1;
        break;
      // Create crop box
      case Dn:
        if (!g.x || !g.y) {
          E = !1;
          break;
        }
        N = Un(this.cropper), c = R.startX - N.left, u = R.startY - N.top, d = n.minWidth, h = n.minHeight, g.x > 0 ? o = g.y > 0 ? Ut : jt : g.x < 0 && (c -= d, o = g.y > 0 ? $t : zt), g.y < 0 && (u -= h), this.cropped || (Me(this.cropBox, ve), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    E && (n.width = d, n.height = h, n.left = c, n.top = u, this.action = o, this.renderCropBox()), ne(a, function(w) {
      w.startX = w.endX, w.startY = w.endY;
    });
  }
}, Zc = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && oe(this.dragBox, yi), Me(this.cropBox, ve), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = Z({}, this.initialImageData), this.canvasData = Z({}, this.initialCanvasData), this.cropBoxData = Z({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (Z(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Me(this.dragBox, yi), oe(this.cropBox, ve)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, ne(this.previews, function(r) {
      r.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Me(this.cropper, bs)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, oe(this.cropper, bs)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[J] ? (e[J] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, s = r.left, n = r.top;
    return this.moveTo(Li(e) ? e : s + Number(e), Li(t) ? t : n + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, s = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (z(e) && (r.left = e, s = !0), z(t) && (r.top = t, s = !0), s && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var r = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(r.width * e / r.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, r) {
    var s = this.options, n = this.canvasData, a = n.width, o = n.height, l = n.naturalWidth, c = n.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && s.zoomable) {
      var u = l * e, d = c * e;
      if (wt(this.element, dr, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: r
      }) === !1)
        return this;
      if (r) {
        var h = this.pointers, p = Un(this.cropper), m = h && Object.keys(h).length ? zc(h) : {
          pageX: r.pageX,
          pageY: r.pageY
        };
        n.left -= (u - a) * ((m.pageX - p.left - n.left) / a), n.top -= (d - o) * ((m.pageY - p.top - n.top) / o);
      } else pt(t) && z(t.x) && z(t.y) ? (n.left -= (u - a) * ((t.x - n.left) / a), n.top -= (d - o) * ((t.y - n.top) / o)) : (n.left -= (u - a) / 2, n.top -= (d - o) / 2);
      n.width = u, n.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), z(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, z(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(z(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.imageData, s = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (z(e) && (r.scaleX = e, s = !0), z(t) && (r.scaleY = t, s = !0), s && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, r = this.imageData, s = this.canvasData, n = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: n.left - s.left,
        y: n.top - s.top,
        width: n.width,
        height: n.height
      };
      var o = r.width / r.naturalWidth;
      if (ne(a, function(u, d) {
        a[d] = u / o;
      }), e) {
        var l = Math.round(a.y + a.height), c = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = c - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (a.rotate = r.rotate || 0), t.scalable && (a.scaleX = r.scaleX || 1, a.scaleY = r.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, r = this.imageData, s = this.canvasData, n = {};
    if (this.ready && !this.disabled && pt(e)) {
      var a = !1;
      t.rotatable && z(e.rotate) && e.rotate !== r.rotate && (r.rotate = e.rotate, a = !0), t.scalable && (z(e.scaleX) && e.scaleX !== r.scaleX && (r.scaleX = e.scaleX, a = !0), z(e.scaleY) && e.scaleY !== r.scaleY && (r.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var o = r.width / r.naturalWidth;
      z(e.x) && (n.left = e.x * o + s.left), z(e.y) && (n.top = e.y * o + s.top), z(e.width) && (n.width = e.width * o), z(e.height) && (n.height = e.height * o), this.setCropBoxData(n);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? Z({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? Z({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && ne(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(r) {
      t[r] = e[r];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, r = t.aspectRatio;
    return this.ready && !this.disabled && pt(e) && (z(e.left) && (t.left = e.left), z(e.top) && (t.top = e.top), z(e.width) ? (t.width = e.width, t.height = e.width / r) : z(e.height) && (t.height = e.height, t.width = e.height * r), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, r = this.options.aspectRatio, s, n;
    return this.ready && this.cropped && !this.disabled && pt(e) && (z(e.left) && (t.left = e.left), z(e.top) && (t.top = e.top), z(e.width) && e.width !== t.width && (s = !0, t.width = e.width), z(e.height) && e.height !== t.height && (n = !0, t.height = e.height), r && (s ? t.height = t.width / r : n && (t.width = t.height * r)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, r = $c(this.image, this.imageData, t, e);
    if (!this.cropped)
      return r;
    var s = this.getData(e.rounded), n = s.x, a = s.y, o = s.width, l = s.height, c = r.width / Math.floor(t.naturalWidth);
    c !== 1 && (n *= c, a *= c, o *= c, l *= c);
    var u = o / l, d = Ye({
      aspectRatio: u,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), h = Ye({
      aspectRatio: u,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), p = Ye({
      aspectRatio: u,
      width: e.width || (c !== 1 ? r.width : o),
      height: e.height || (c !== 1 ? r.height : l)
    }), m = p.width, v = p.height;
    m = Math.min(d.width, Math.max(h.width, m)), v = Math.min(d.height, Math.max(h.height, v));
    var y = document.createElement("canvas"), S = y.getContext("2d");
    y.width = bt(m), y.height = bt(v), S.fillStyle = e.fillColor || "transparent", S.fillRect(0, 0, m, v);
    var O = e.imageSmoothingEnabled, E = O === void 0 ? !0 : O, N = e.imageSmoothingQuality;
    S.imageSmoothingEnabled = E, N && (S.imageSmoothingQuality = N);
    var R = r.width, g = r.height, C = n, w = a, x, _, F, I, H, U;
    C <= -o || C > R ? (C = 0, x = 0, F = 0, H = 0) : C <= 0 ? (F = -C, C = 0, x = Math.min(R, o + C), H = x) : C <= R && (F = 0, x = Math.min(o, R - C), H = x), x <= 0 || w <= -l || w > g ? (w = 0, _ = 0, I = 0, U = 0) : w <= 0 ? (I = -w, w = 0, _ = Math.min(g, l + w), U = _) : w <= g && (I = 0, _ = Math.min(l, g - w), U = _);
    var Q = [C, w, x, _];
    if (H > 0 && U > 0) {
      var M = m / o;
      Q.push(F * M, I * M, H * M, U * M);
    }
    return S.drawImage.apply(S, [r].concat(Pn(Q.map(function(ae) {
      return Math.floor(bt(ae));
    })))), y;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !Li(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, r = this.dragBox, s = this.face;
    if (this.ready && !this.disabled) {
      var n = e === Er, a = t.movable && e === Ln;
      e = n || a ? e : kn, t.dragMode = e, Xt(r, Yt, e), mt(r, ar, n), mt(r, or, a), t.cropBoxMovable || (Xt(s, Yt, e), mt(s, ar, n), mt(s, or, a));
    }
    return this;
  }
}, eu = Te.Cropper, Bn = /* @__PURE__ */ (function() {
  function i(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (fc(this, i), !e || !_c.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = Z({}, Ps, pt(t) && t), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return pc(i, [{
    key: "init",
    value: function() {
      var t = this.element, r = t.tagName.toLowerCase(), s;
      if (!t[J]) {
        if (t[J] = this, r === "img") {
          if (this.isImg = !0, s = t.getAttribute("src") || "", this.originalUrl = s, !s)
            return;
          s = t.src;
        } else r === "canvas" && window.HTMLCanvasElement && (s = t.toDataURL());
        this.load(s);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var r = this;
      if (t) {
        this.url = t, this.imageData = {};
        var s = this.element, n = this.options;
        if (!n.rotatable && !n.scalable && (n.checkOrientation = !1), !n.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Ec.test(t)) {
          Nc.test(t) ? this.read(Vc(t)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), o = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = o, a.onerror = o, a.ontimeout = o, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Rs && a.abort();
        }, a.onload = function() {
          r.read(a.response);
        }, a.onloadend = function() {
          r.reloading = !1, r.xhr = null;
        }, n.checkCrossOrigin && Fs(t) && s.crossOrigin && (t = Is(t)), a.open("GET", t, !0), a.responseType = "arraybuffer", a.withCredentials = s.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var r = this.options, s = this.imageData, n = Kc(t), a = 0, o = 1, l = 1;
      if (n > 1) {
        this.url = Wc(t, Rs);
        var c = Qc(n);
        a = c.rotate, o = c.scaleX, l = c.scaleY;
      }
      r.rotatable && (s.rotate = a), r.scalable && (s.scaleX = o, s.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, r = this.url, s = t.crossOrigin, n = r;
      this.options.checkCrossOrigin && Fs(r) && (s || (s = "anonymous"), n = Is(r)), this.crossOrigin = s, this.crossOriginUrl = n;
      var a = document.createElement("img");
      s && (a.crossOrigin = s), a.src = n || r, a.alt = t.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), oe(a, ws), t.parentNode.insertBefore(a, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, r = this.image;
      r.onload = null, r.onerror = null, this.sizing = !0;
      var s = Te.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(Te.navigator.userAgent), n = function(c, u) {
        Z(t.imageData, {
          naturalWidth: c,
          naturalHeight: u,
          aspectRatio: c / u
        }), t.initialImageData = Z({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (r.naturalWidth && !s) {
        n(r.naturalWidth, r.naturalHeight);
        return;
      }
      var a = document.createElement("img"), o = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        n(a.width, a.height), s || o.removeChild(a);
      }, a.src = r.src, s || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", o.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, r = this.options, s = this.image, n = t.parentNode, a = document.createElement("div");
        a.innerHTML = Rc;
        var o = a.querySelector(".".concat(J, "-container")), l = o.querySelector(".".concat(J, "-canvas")), c = o.querySelector(".".concat(J, "-drag-box")), u = o.querySelector(".".concat(J, "-crop-box")), d = u.querySelector(".".concat(J, "-face"));
        this.container = n, this.cropper = o, this.canvas = l, this.dragBox = c, this.cropBox = u, this.viewBox = o.querySelector(".".concat(J, "-view-box")), this.face = d, l.appendChild(s), oe(t, ve), n.insertBefore(o, t.nextSibling), Me(s, ws), this.initPreview(), this.bind(), r.initialAspectRatio = Math.max(0, r.initialAspectRatio) || NaN, r.aspectRatio = Math.max(0, r.aspectRatio) || NaN, r.viewMode = Math.max(0, Math.min(3, Math.round(r.viewMode))) || 0, oe(u, ve), r.guides || oe(u.getElementsByClassName("".concat(J, "-dashed")), ve), r.center || oe(u.getElementsByClassName("".concat(J, "-center")), ve), r.background && oe(o, "".concat(J, "-bg")), r.highlight || oe(d, wc), r.cropBoxMovable && (oe(d, or), Xt(d, Yt, Or)), r.cropBoxResizable || (oe(u.getElementsByClassName("".concat(J, "-line")), ve), oe(u.getElementsByClassName("".concat(J, "-point")), ve)), this.render(), this.ready = !0, this.setDragMode(r.dragMode), r.autoCrop && this.crop(), this.setData(r.data), ge(r.ready) && xe(t, Es, r.ready, {
          once: !0
        }), wt(t, Es);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), Me(this.element, ve);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = eu, i;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      Z(Ps, pt(t) && t);
    }
  }]);
})();
Z(Bn.prototype, qc, Yc, Xc, Gc, Jc, Zc);
var Ze = function() {
  return Ze = Object.assign || function(i) {
    for (var e, t = 1, r = arguments.length; t < r; t++) for (var s in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, s) && (i[s] = e[s]);
    return i;
  }, Ze.apply(this, arguments);
};
function Mi(i, e) {
  var t = {};
  for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function") {
    var s = 0;
    for (r = Object.getOwnPropertySymbols(i); s < r.length; s++) e.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(i, r[s]) && (t[r[s]] = i[r[s]]);
  }
  return t;
}
var tu = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], iu = { opacity: 0, maxWidth: "100%" }, ru = Oe.forwardRef((function(i, e) {
  var t = Mi(i, []), r = t.dragMode, s = r === void 0 ? "crop" : r, n = t.src, a = t.style, o = t.className, l = t.crossOrigin, c = t.scaleX, u = t.scaleY, d = t.enable, h = t.zoomTo, p = t.rotateTo, m = t.alt, v = m === void 0 ? "picture" : m, y = t.ready, S = t.onInitialized, O = Mi(t, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), E = { scaleY: u, scaleX: c, enable: d, zoomTo: h, rotateTo: p }, N = (function() {
    for (var g = [], C = 0; C < arguments.length; C++) g[C] = arguments[C];
    var w = we(null);
    return Oe.useEffect((function() {
      g.forEach((function(x) {
        x && (typeof x == "function" ? x(w.current) : x.current = w.current);
      }));
    }), [g]), w;
  })(e, we(null));
  Ee((function() {
    var g;
    !((g = N.current) === null || g === void 0) && g.cropper && typeof h == "number" && N.current.cropper.zoomTo(h);
  }), [t.zoomTo]), Ee((function() {
    var g;
    !((g = N.current) === null || g === void 0) && g.cropper && n !== void 0 && N.current.cropper.reset().clear().replace(n);
  }), [n]), Ee((function() {
    if (N.current !== null) {
      var g = new Bn(N.current, Ze(Ze({ dragMode: s }, O), { ready: function(C) {
        C.currentTarget !== null && (function(w, x) {
          x === void 0 && (x = {});
          var _ = x.enable, F = _ === void 0 || _, I = x.scaleX, H = I === void 0 ? 1 : I, U = x.scaleY, Q = U === void 0 ? 1 : U, M = x.zoomTo, ae = M === void 0 ? 0 : M, T = x.rotateTo;
          F ? w.enable() : w.disable(), w.scaleX(H), w.scaleY(Q), T !== void 0 && w.rotateTo(T), ae > 0 && w.zoomTo(ae);
        })(C.currentTarget.cropper, E), y && y(C);
      } }));
      S && S(g);
    }
    return function() {
      var C, w;
      (w = (C = N.current) === null || C === void 0 ? void 0 : C.cropper) === null || w === void 0 || w.destroy();
    };
  }), [N]);
  var R = (function(g) {
    return tu.reduce((function(C, w) {
      var x = C, _ = w;
      return x[_], Mi(x, [typeof _ == "symbol" ? _ : _ + ""]);
    }), g);
  })(Ze(Ze({}, O), { crossOrigin: l, src: n, alt: v }));
  return Oe.createElement("div", { style: a, className: o }, Oe.createElement("img", Ze({}, R, { style: iu, ref: N })));
}));
const Hn = ha(
  ({ imageCropperRef: i, isRounded: e, imageFile: t, imageCropperProps: r }) => {
    const {
      viewMode: s = 1,
      autoCropArea: n = 1,
      aspectRatio: a = 1,
      checkOrientation: o = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: c = "move",
      toggleDragModeOnDblclick: u = !1,
      style: d = { height: 400, width: "100%" },
      ...h
    } = r || {}, p = we(null), m = we(null), v = we(null), y = we(null), S = () => {
      m.current && (m.current.style.opacity = ""), v.current && (v.current.style.display = "block"), y.current && (y.current.style.zIndex = "", y.current.innerText = "");
    }, O = () => {
      v.current && y.current && (y.current.appendChild(v.current.cloneNode(!0)), y.current.style.zIndex = "1000", v.current.style.display = "none"), m.current && (m.current.style.opacity = "0");
    }, E = (N) => new Promise((R, g) => {
      var C;
      try {
        const w = (C = p.current) == null ? void 0 : C.cropper;
        if (!w) throw new Error();
        if (e) {
          const x = w == null ? void 0 : w.getCroppedCanvas();
          if (!x) throw new Error();
          const _ = Math.min(x.width, x.height), F = document.createElement("canvas");
          F.width = _, F.height = _;
          const I = F.getContext("2d");
          if (!I) throw new Error();
          I.beginPath(), I.arc(_ / 2, _ / 2, _ / 2, 0, Math.PI * 2), I.closePath(), I.clip(), I.drawImage(x, 0, 0, _, _), F.toBlob((H) => {
            if (!t || !H)
              return g(new Error());
            const U = is(
              ns(t, H),
              a
            );
            R(U);
          });
        } else
          w.getCroppedCanvas(N).toBlob((x) => {
            if (!t || !x)
              return g(new Error());
            const _ = is(
              ns(t, x),
              a
            );
            R(_);
          });
      } catch (w) {
        g(w);
      }
    });
    return i && (i.current = {
      hidePreview: S,
      showPreview: O,
      getCroppedFile: E
    }), /* @__PURE__ */ b("div", { children: /* @__PURE__ */ j("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ b(
        "div",
        {
          ref: y,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ b(
        "div",
        {
          ref: v,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: d.width,
            height: d.height,
            borderRadius: e ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ b("div", { ref: m, children: /* @__PURE__ */ b(
        ru,
        {
          className: e ? "sio-cropper-rounded" : "",
          ref: p,
          src: t && URL.createObjectURL(t),
          preview: v || void 0,
          style: d,
          viewMode: s,
          background: l,
          autoCropArea: n,
          aspectRatio: a,
          checkOrientation: o,
          dragMode: c,
          toggleDragModeOnDblclick: u,
          ...h
        }
      ) })
    ] }) });
  }
);
Hn.displayName = "ImageCropper";
function Vn({
  imageFile: i,
  opened: e,
  actionButtonLabel: t,
  isFetching: r,
  onClose: s,
  onCrop: n,
  ...a
}) {
  const { t: o } = pe(), l = we(), [c, u] = V(!1), d = (p) => {
    var m, v;
    u(p), p ? (m = l.current) == null || m.showPreview() : (v = l.current) == null || v.hidePreview();
  }, h = async () => {
    var p;
    try {
      const m = await ((p = l.current) == null ? void 0 : p.getCroppedFile());
      if (!m) throw new Error();
      n(m);
    } catch {
      be.error(o("file_manager.error"));
    }
  };
  return /* @__PURE__ */ j(
    bi,
    {
      title: o("file_manager.file_upload.crop_file"),
      opened: e,
      onClose: s,
      afterLeave: () => u(!1),
      isFetching: r,
      isCentered: !0,
      children: [
        /* @__PURE__ */ b(Hn, { imageCropperRef: l, imageFile: i, ...a }),
        /* @__PURE__ */ j("div", { className: "mt-10 flex items-center justify-between", children: [
          /* @__PURE__ */ b(
            sa,
            {
              label: o("file_manager.preview"),
              selected: c,
              onChange: d
            }
          ),
          /* @__PURE__ */ b(ti, { onClick: h, isFetching: r, children: t ?? o("file_manager.file_upload.crop_file") })
        ] })
      ]
    }
  );
}
const su = ({
  uploaderRef: i,
  opened: e,
  source: t,
  imageCropperModalProps: r,
  showCroppingNote: s,
  acceptTypes: n,
  fileManagerApiType: a,
  actionLabel: o,
  singleFileMode: l,
  openCroppingModalOnAdding: c,
  requireCropping: u,
  onClose: d,
  onUploadFinish: h
}) => {
  const { t: p } = pe(), [m, v] = V(!1), [y, S] = V(), {
    waitingUploadFiles: O,
    setWaitingUploadFiles: E,
    removingFiles: N,
    mappedUploadedFiles: R,
    mappedUploadingFiles: g,
    startUploading: C,
    setUploadedFiles: w,
    deleteUploadedOrUploadingFile: x
  } = ac({
    fileManagerApiType: a,
    source: t
  }), _ = async (D) => {
    var ri;
    const A = (ri = r == null ? void 0 : r.imageCropperProps) == null ? void 0 : ri.aspectRatio;
    if (!$i(D) || !A || isNaN(A))
      return !0;
    const Y = URL.createObjectURL(D), [he, kt] = await tn(Y);
    return !!rn(kt, A);
  };
  rs(O, async (D, A) => {
    if (!c) return;
    const { added: Y } = D ? ss(D, A) : { added: A };
    for (const { file: he } of Y)
      if (!await _(he)) {
        q(he);
        break;
      }
  }), rs(O, async (D, A) => {
    if (!s) return;
    const { added: Y } = D ? ss(D, A) : { added: A };
    for (const { file: he } of Y)
      if (!await _(he)) {
        be(p("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
        break;
      }
  });
  const F = async (D) => {
    E(l ? [{ file: D }] : (A) => [{ file: D }, ...A]);
  }, I = async (D) => {
    try {
      oc(D) && E((A) => A == null ? void 0 : A.filter((Y) => Y.file !== D)), lc(D) && (await x(D.id), E((A) => A == null ? void 0 : A.filter((Y) => Y.file !== D.file))), cc(D) && await x(D.id);
    } catch {
      be.error(p("file_manager.error"));
    }
  }, H = async () => {
    try {
      if (S(void 0), v(!0), u) {
        for await (const { file: Y } of O)
          if (!await _(Y))
            throw new Error(p("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
      }
      const D = [], A = await Promise.allSettled(
        O.map(
          ({ file: Y }) => C(Y).catch(() => {
            D.push(p("file_manager.error") + ": " + Y.name);
          })
        )
      );
      if (D.length)
        throw new Error(D.join(", "));
      await h(
        A.map((Y) => {
          if (Y.status === "fulfilled")
            return Y.value;
        })
      ), be.success(p("file_manager.file_upload.uploaded_successfully"));
    } catch (D) {
      const A = D instanceof Error ? D : new Error(p("file_manager.error"));
      S(A);
    } finally {
      v(!1);
    }
  }, U = !![...O, ...g, ...R].length, [Q, M] = V(!1), [ae, T] = V(), q = (D) => {
    M(!0), T(D);
  }, ee = () => {
    M(!1), T(void 0);
  }, W = (D) => {
    E(
      (A) => A.map((Y) => Y.file === ae ? { file: D } : Y)
    ), ee();
  };
  return i && (i.current = {
    setWaitingUploadFiles: E
  }), /* @__PURE__ */ j(Ti, { children: [
    /* @__PURE__ */ b(
      bi,
      {
        title: p("file_manager.file_upload.upload_files"),
        isCentered: !0,
        isFetching: m,
        opened: e,
        onClose: d,
        afterLeave: () => {
          w([]), E([]);
        },
        children: /* @__PURE__ */ j("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ j(
            Nn,
            {
              acceptTypes: n,
              onSelectFile: F,
              dropZoneClassName: ie("min-h-[400px]", !U && "items-center"),
              label: p("file_manager.file_upload.drop_files_here"),
              disabled: m,
              children: [
                O.map((D, A) => /* @__PURE__ */ b("div", { title: D.file.name, children: /* @__PURE__ */ b(
                  Ii,
                  {
                    file: D.file,
                    isError: !!D.error,
                    onDeleteFile: () => I(D.file),
                    showDeleteButton: !0,
                    showEditButton: $i(D.file),
                    onEdit: () => q(D.file)
                  }
                ) }, A + D.file.name)),
                g.map((D) => /* @__PURE__ */ b("div", { title: D.file.name, children: /* @__PURE__ */ b(
                  Ii,
                  {
                    file: D.file.file,
                    progress: D.progress,
                    isLoading: !0,
                    onDeleteFile: () => I(D.file)
                  }
                ) }, D.file.id)),
                R.map((D) => /* @__PURE__ */ b("div", { title: D.file.name, children: /* @__PURE__ */ b(
                  Ii,
                  {
                    file: D.file,
                    progress: D.progress,
                    isLoaded: !0,
                    isDeleting: N.includes(D.file.id),
                    onDeleteFile: () => I(D.file)
                  }
                ) }, D.file.id))
              ]
            }
          ),
          /* @__PURE__ */ b("div", { children: /* @__PURE__ */ b(
            ui,
            {
              error: y == null ? void 0 : y.message,
              className: "text-center"
            }
          ) }),
          /* @__PURE__ */ j("div", { className: "flex justify-end gap-3", children: [
            /* @__PURE__ */ b(Bs, { disabled: m, onClick: () => d(), children: p("file_manager.cancel") }),
            /* @__PURE__ */ b(
              ti,
              {
                isFetching: m,
                onClick: H,
                disabled: !U,
                children: o ?? p("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ b(
      Vn,
      {
        imageFile: ae,
        opened: Q,
        onClose: ee,
        onCrop: W,
        ...r
      }
    )
  ] });
};
function nu({
  uploadingFromSource: i,
  requiredCropping: e = !0,
  fileUploaderModalProps: t,
  initialSearchFilters: r,
  disabledFileTypeSelect: s,
  disabledFileSourceSelect: n,
  fileSelectorRef: a,
  onSelect: o,
  fileManagerApiType: l
}) {
  var Ir, Lr;
  e = !!(e && ((Lr = (Ir = t == null ? void 0 : t.imageCropperModalProps) == null ? void 0 : Ir.imageCropperProps) != null && Lr.aspectRatio));
  const { t: c } = pe(), { width: u } = na(), [d, h] = V(
    r ?? {
      name: "",
      source: [],
      type: []
    }
  ), [p, m] = V(d), [v, y] = V(), [S, O] = V(), [E, N] = V(), [R, g] = V(""), [C, w] = V(), x = Al({
    filter: p,
    sortColumn: "createdAt",
    sortDirection: Vs.Desc,
    fileManagerApiType: l
  }), { resetAndRefetch: _, deleteItemFromData: F, renameItemFromData: I } = x, { deleteFile: H, downloadFile: U, renameFile: Q } = Cn(), { data: M, isFetching: ae } = jl({
    id: v == null ? void 0 : v.id,
    fileManagerApiType: l
  }), T = async () => {
    S && (await H(S), F(S.id), be.success(c("file_manager.file_deleted_successfully")), O(void 0));
  }, q = async (se) => {
    try {
      await U(se);
    } catch {
    }
  }, [ee, W] = V(), D = async () => {
    var se;
    if (E)
      try {
        W(void 0), await Q({ id: E.id, name: R }), I({ id: E.id, name: R }), be.success(c("file_manager.file_renamed_successfully")), N(void 0);
      } catch (Ne) {
        if (Ne instanceof Ca)
          W((se = Ne.errors.fields.name) == null ? void 0 : se.join(" "));
        else
          throw Ne;
      }
  }, A = we(), [Y, he] = V(!1), kt = (se) => {
    var Ne;
    (Ne = A.current) == null || Ne.setWaitingUploadFiles((Xe) => [...Xe, { file: se }]), he(!0);
  };
  Ee(() => {
    t != null && t.uploaderRef && (t.uploaderRef.current = A.current);
  }, [A.current]), a && (a.current = {
    setFileUploadModalOpen: he
  });
  const { createFileUploader: ri } = On(l), [Wn, _r] = V(!1), [Kn, Rr] = V(!1), [Qn, Pr] = V(!1), [qn, Dr] = V(), Yn = (se) => {
    _r(!0), Dr(se);
  }, Fr = () => {
    _r(!1), Dr(void 0);
  }, Xn = async (se) => {
    try {
      Rr(!0);
      const Xe = await ri(() => {
      }).upload({
        file: se,
        source: i
      });
      if (!Xe) throw new Error();
      const si = Ao(Xe, i);
      o(si), _(), Fr();
    } catch {
      be.error(c("file_manager.error"));
    } finally {
      Rr(!1);
    }
  }, Gn = async () => {
    var Ne, Xe;
    if (!C) return;
    const se = (Xe = (Ne = t == null ? void 0 : t.imageCropperModalProps) == null ? void 0 : Ne.imageCropperProps) == null ? void 0 : Xe.aspectRatio;
    if (!e || !$i(C) || !se || isNaN(se)) {
      o(C);
      return;
    }
    try {
      Pr(!0);
      const [si, Jn] = await tn(C.path);
      if (rn(Jn, se)) {
        o(C);
        return;
      }
      be(To(se));
      const Zn = await jo(si, C.name, C.type);
      Yn(Zn);
    } catch {
      be.error(c("file_manager.error"));
    } finally {
      Pr(!1);
    }
  };
  return /* @__PURE__ */ j("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ b(
      "div",
      {
        className: ie(
          v ? "w-1/2" : "w-full",
          u < 1024 && v ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ j("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ b(
            zl,
            {
              isFetching: x.isFetching,
              values: d,
              disabledFileSourceSelect: n,
              disabledFileTypeSelect: s,
              onChange: h,
              onSubmit: () => {
                m(d);
              }
            }
          ),
          /* @__PURE__ */ b(
            tc,
            {
              dataFilesApi: x,
              onDetails: y,
              onSelect: w,
              specialElementInGrid: /* @__PURE__ */ b(
                Nn,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelectFile: kt
                }
              ),
              ...!(l != null && l.isCommon) && {
                onDelete: O,
                onDownload: q,
                onRename: (se) => {
                  N(se), g(se.name);
                }
              }
            }
          ),
          /* @__PURE__ */ j("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ j("div", { className: "text-text-tertiary text-sm", children: [
              +!!C,
              " ",
              c("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ b(
              ti,
              {
                className: "min-w-14",
                disabled: C === void 0,
                isFetching: Qn,
                onClick: () => Gn(),
                children: c("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    v && /* @__PURE__ */ b(
      $o,
      {
        className: ie(u < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: M == null ? void 0 : M.type,
        src: (M == null ? void 0 : M.path) ?? (M == null ? void 0 : M.thumbnail) ?? void 0,
        alt: M == null ? void 0 : M.name,
        name: M == null ? void 0 : M.name,
        size: M == null ? void 0 : M.size,
        onClose: () => y(void 0),
        isFetching: ae
      }
    ),
    /* @__PURE__ */ b(
      os,
      {
        opened: !!S,
        onClose: () => O(void 0),
        confirmationText: c("file_manager.file_selector.file_deletion_confirmation_text", {
          file: S == null ? void 0 : S.name
        }),
        onConfirm: () => T()
      }
    ),
    /* @__PURE__ */ b(
      os,
      {
        opened: !!E,
        onClose: () => {
          N(void 0), W(void 0);
        },
        title: c("file_manager.file_selector.rename_file"),
        confirmButtonCaption: c("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ b(
          aa,
          {
            label: c("file_manager.file_selector.file_name"),
            placeholder: c("file_manager.file_selector.enter_new_file_name"),
            value: R,
            onChange: (se) => g(se.target.value),
            error: ee
          }
        ),
        onConfirm: () => D()
      }
    ),
    /* @__PURE__ */ b(
      su,
      {
        ...t,
        uploaderRef: A,
        opened: Y,
        source: i,
        showCroppingNote: e,
        onClose: () => he(!1),
        onUploadFinish: () => {
          _(), he(!1);
        },
        fileManagerApiType: l
      }
    ),
    /* @__PURE__ */ b(
      Vn,
      {
        isFetching: Kn,
        imageFile: qn,
        opened: Wn,
        onClose: Fr,
        onCrop: Xn,
        actionButtonLabel: c("file_manager.file_upload.crop_and_select_file"),
        ...t == null ? void 0 : t.imageCropperModalProps
      }
    )
  ] });
}
function wu({
  title: i,
  opened: e,
  onClose: t,
  onSelect: r,
  ...s
}) {
  const { t: n } = pe();
  return /* @__PURE__ */ b(
    bi,
    {
      title: i ?? n("file_manager.file_selector.choose_file"),
      opened: e,
      isCentered: !0,
      size: oa.big,
      onClose: t,
      children: /* @__PURE__ */ b(nu, { onSelect: r, ...s })
    }
  );
}
export {
  _a as AudioFileIcon,
  os as ConfirmationModal,
  jr as DocumentFileIcon,
  Ho as FileActionMenuDeleteItem,
  Bo as FileActionMenuDetailsItem,
  Wo as FileActionMenuDownloadItem,
  Vo as FileActionMenuRenameItem,
  $o as FileDetails,
  En as FileDropZoneVariantEnum,
  ze as FileExtensionEnum,
  tc as FileGrid,
  Fa as FileItem,
  ot as FilePreview,
  nn as FilePreviewFromOS,
  zl as FileSearch,
  nu as FileSelector,
  wu as FileSelectorModal,
  G as FileSourceEnum,
  Ea as FileSourceEnumLocoKeys,
  X as FileTypeEnum,
  Na as FileTypeEnumLocoKeys,
  Nn as FileUploaderDropZone,
  Ii as FileUploaderItem,
  su as FileUploaderModal,
  Hn as ImageCropper,
  Vn as ImageCropperModal,
  Ra as ImageFileIcon,
  _l as LocaleContext,
  yu as LocaleProvider,
  mr as PaginationOrderEnum,
  vu as QueryClientProvider,
  Vs as SortDirectionEnum,
  Pa as VideoFileIcon,
  is as appendAspectRatioToFileName,
  rn as areAspectRatiosEqual,
  Ao as convertFileInfoToDataFile,
  rc as createCanceler,
  sc as createProgress,
  mu as fileInputAcceptTypes,
  Uo as formatAcceptTypeForInput,
  ko as formatBytes,
  ss as getArrayDifference,
  sn as getAspectRatioLabel,
  To as getAspectRatioNote,
  gu as getFileTypeFromName,
  tn as getImageAspectRatio,
  nc as getMimeType,
  Da as getThumbnailByType,
  zo as hashFile,
  vr as httpClient,
  re as i18n,
  jo as imageToFile,
  as as isAcceptTypeValid,
  Oa as isDataFileInterface,
  cc as isFileInfoInterface,
  $i as isImageFile,
  oc as isOsFile,
  lc as isOsFileWithId,
  Lo as loadLangBundle,
  gr as namespace,
  ns as replaceImageFileBlob,
  en as t,
  bu as useDataFiles,
  vt as useFetch,
  Cn as useFileActions,
  jl as useFileDetails,
  On as useFileUploader,
  ic as useFileUploaderActions,
  ac as useFileUploaderManager,
  Al as useInfiniteDataFiles,
  rs as useStateWatcher,
  pe as useTranslation,
  hc as variantClassName
};
